
import React from 'react';
import '../template-file-css/document-file-template.css';


export const FYD_ChildAssessment = ({
    itemsRef,
    showErrorFor,
}) => {

    return (
        <form id='FYD_ChildAssessment' className='file-pdf-document'>
            <div className='file-template'>


                <h3>DEMOGRAPHIC INFORMATION</h3>

                <table>
                    <tr>
                        <td className='w-375'><span className='eleHeader'>Age:</span></td>
                        <td className='w-375'><span className='eleHeader'>Gender Expression:</span></td>
                    </tr>
                    <tr>
                        <td className='w-375'> <input type="text" id="txtAge" name="txtAge" className='add-only' /></td>
                        <td className='w-375'> <input type="text" id="txtGenderExpression" name="txtGenderExpression" className='add-only' /></td>
                    </tr>
                </table>
                <table>
                    <tr>
                        <td className='w-750'>
                            <span className='eleHeader'>Parent/Primary Caretaker Name:
                            </span>
                        </td>
                    </tr>
                    <tr>
                        <td className='w-750'>
                            <input type="text" id="txtCaretakerName" name="txtCaretakerName" className='add-only' />
                        </td>
                    </tr>
                    <tr>
                        <td className='w-750'>Is this person, the legal guardian?</td>
                    </tr>
                    <tr>
                        <td className='w-750'>
                            <input type="radio" id="rbIsThisPersonTheLegalGuardian_Yes" name="rbIsThisPersonTheLegalGuardian" className='add-only' value="Yes" /> Yes &nbsp;

                            <input type="radio" id="rbIsThisPersonTheLegalGuardian_No" name="rbIsThisPersonTheLegalGuardian" className='add-only' value="No" /> No (if not, enter information below)
                        </td>
                    </tr>
                    <tr>
                        <td className='w-375'><span className='eleHeader'>Legal Guardian Name:</span> </td>
                        <td className='w-375'><span className='eleHeader'>Title/Department:</span> </td>
                    </tr>
                    <tr>
                        <td className='w-375'>
                            <input type="text" id="txtLegalGuardianName" name="txtLegalGuardianName" className='add-only' />
                        </td>
                        <td className='w-375'>
                            <input type="text" id="txtTitleDepartment" name="txtTitleDepartment" className='add-only' />
                        </td>
                    </tr>
                    <tr>
                        <td className='w-375'><span className='eleHeader'>Phone Number:</span> </td>
                        <td className='w-375'><span className='eleHeader'>Address:</span> </td>
                    </tr>
                    <tr>
                        <td className='w-375'>
                            <input type="text" id="txtPhoneNumber" name="txtPhoneNumber" className='add-only' />
                        </td>
                        <td className='w-375'>
                            <input type="text" id="txtAddress" name="txtAddress" className='add-only' />
                        </td>
                    </tr>
                    <tr>
                        <td className='w-375'><span className='eleHeader'>City:</span> </td>
                        <td className='w-375'><span className='eleHeader'>Zip Code:</span> </td>
                    </tr>
                    <tr>
                        <td className='w-375'>
                            <input type="text" id="txtCity" name="txtCity" className='add-only' />
                        </td>
                        <td className='w-375'>
                            <input type="text" id="txtZipCode" name="txtZipCode" className='add-only' />
                        </td>
                    </tr>
                    <tr>
                        <td className='w-750'>
                            <strong>CALOCUS</strong>
                        </td>
                    </tr>
                    <tr>
                        <td className='w-375'>
                            <span className='eleHeader'>COMPOSITE:</span>
                            <input type="text" id="txtComposite" name="txtComposite" className='add-only' />
                        </td>
                        <td className='w-375'>
                            <span className='eleHeader'>LOC:</span>
                            <input type="text" id="txtLoc" name="txtLoc" className='add-only' />
                        </td>
                    </tr>
                </table>
                <p className='w-750'>
                    <span className='eleHeader'>PRIMARY DIAGNOSIS:</span>
                    <textarea id="txtPrimaryDiagnosis" name="txtPrimaryDiagnosis" className='add-only'></textarea>
                </p>


                <h3>BEHAVIORAL HEALTH HISTORY</h3>
                <p className='w-750'>
                    <strong>I. CHIEF COMPLAINT </strong>
                    <span className='small'>(Major symptoms, difficulties, and/or Issues as they relate to behavioral health -in recipient's own words/quoted.)</span>
                    <textarea id="txtReportedFelling" name="txtReportedFelling" className='add-only'></textarea>
                </p>

                <p className='w-750'>
                    <strong>II. PRESENTING PROBLEM/RELEVENT HISTORY </strong>
                    <span className='small'>(Including recipient's reason for seeking services,precipitating factors, symptoms, behavioral and functioning impacts, onset/course of issues, current behavioral health providers, services sought and recipient expectation.)</span>
                </p>
                <table>
                    <tr>
                        <td className='w-375'><span className='eleHeader'>CURRENT BEHAVIORAL HEALTH PROVIDER NAME:</span> </td>
                        <td className='w-375'><span className='eleHeader'>PHONE NUMBER:</span> </td>
                    </tr>
                    <tr>
                        <td className='w-375'>
                            <input type="text" id="txtHealthProviderName" name="txtHealthProviderName" className='add-only' />
                        </td>
                        <td className='w-375'>
                            <input type="text" id="txtHealthProviderPhoneNumber" name="txtHealthProviderPhoneNumber" className='add-only' />
                        </td>
                    </tr>
                </table>
                <p className='w-750'>
                    <textarea id="txtPresentingProblem" name="txtPresentingProblem" className='add-only'></textarea>
                </p>

                <p className='w-750'>
                    <strong>III. PAST PSYCHIATRIC HISTORY:</strong>
                    <span className='small'>(First onset of illness, past diagnostic and treatment history, medications, hospitalizations)</span>
                </p>
                <p className='w-750'>
                    <span className='eleHeader'>Prior Outpatient Mental Health Treatment:</span>
                    <input type="radio" id="rbPriorOutpatientMentalHealthTreatment_Yes" name="rbPriorOutpatientMentalHealthTreatment" className='add-only' value="Yes" /> Yes &nbsp;

                    <input type="radio" id="rbPriorOutpatientMentalHealthTreatment_No" name="rbPriorOutpatientMentalHealthTreatment" className='add-only' value="No" /> No
                </p>
                <p className='w-750'>
                    Detail:
                    <br />
                    <textarea id="txtPriorOutpatientMentalHealthTreatmentDetail" name="txtPriorOutpatientMentalHealthTreatmentDetail" className='add-only'></textarea>
                </p>

                <p className='w-750'>
                    <span className='eleHeader'>Psychiatric Hospitalizations:</span>
                    <input type="radio" id="rbPsychiatricHospitalizations_Yes" name="rbPsychiatricHospitalizations" className='add-only' value="Yes" /> Yes &nbsp;

                    <input type="radio" id="rbPsychiatricHospitalizations_No" name="rbPsychiatricHospitalizations" className='add-only' value="No" /> No
                </p>
                <p className='w-750'>
                    Detail:
                    <br />
                    <textarea id="txtPsychiatricHospitalizationsDetail" name="txtPsychiatricHospitalizationsDetail" className='add-only'></textarea>
                </p>

                <p className='w-750'>
                    <span className='eleHeader'>Prior Residential/Out of Home Placement:</span>
                    <input type="radio" id="rbPriorResidentalOutOfHomePlacement_Yes" name="rbPriorResidentalOutOfHomePlacement" className='add-only' value="Yes" /> Yes &nbsp;

                    <input type="radio" id="rbPriorResidentalOutOfHomePlacement_No" name="rbPriorResidentalOutOfHomePlacement" className='add-only' value="No" /> No
                </p>
                <p className='w-750'>
                    Detail:

                    <br />
                    <textarea id="txtPriorResidentalOutOfHomePlacementDetail" name="txtPriorResidentalOutOfHomePlacementDetail" className='add-only'></textarea>
                </p>
                <p className='w-750'>
                    <span className='eleHeader'>Additional History/Comments:</span>
                    <textarea id="txtAdditionalHistoryComments" name="txtAdditionalHistoryComments" className='add-only'></textarea>
                </p>

                <p className='w-750'>
                    <strong>IV. SUBSTANCE USE HISTORY</strong>
                    <span className='small'>(Past use of primary, secondary & tertiary current substance, incl. type, freq, method & age of 1st use.)</span>
                </p>
                <p className='w-750'>
                    Check any/all that apply in past 12 months:
                </p>
                <table>
                    <tr>
                        <td className='w-250'>
                            <input type="checkbox" id="cbSubstanceUseHistory_1" name="cbSubstanceUseHistory_1" className='add-only' value="SubstanceUseHistory_1" />Alcohol Use;
                        </td>
                        <td className='w-250'>
                            <input type="checkbox" id="cbSubstanceUseHistory_2" name="cbSubstanceUseHistory_2" className='add-only' value="SubstanceUseHistory_2" />Illegal Drug Use;
                        </td>
                        <td className='w-250'>
                            <input type="checkbox" id="cbSubstanceUseHistory_3" name="cbSubstanceUseHistory_3" className='add-only' value="SubstanceUseHistory_3" />Injected Drug Use;
                        </td>
                    </tr>
                    <tr>
                        <td className='w-250'>
                            <input type="checkbox" id="cbSubstanceUseHistory_4" name="cbSubstanceUseHistory_4" className='add-only' value="SubstanceUseHistory_4" />Tobacco Product Use;
                        </td>
                        <td className='w-250'>
                            <input type="checkbox" id="cbSubstanceUseHistory_5" name="cbSubstanceUseHistory_5" className='add-only' value="SubstanceUseHistory_5" />Prescription Drugs Misuse;
                        </td>
                        <td className='w-250'>
                            <input type="checkbox" id="cbSubstanceUseHistory_6" name="cbSubstanceUseHistory_6" className='add-only' value="SubstanceUseHistory_6" />Non-Prescription (OTC) Misuse;
                        </td>
                    </tr>
                    <tr>
                        <td className='w-250'>
                            <input type="checkbox" id="cbSubstanceUseHistory_7" name="cbSubstanceUseHistory_7" className='add-only' value="SubstanceUseHistory_7" />Alcohol and/or Drug Overdose;
                        </td>
                        <td className='w-250'>
                            <input type="checkbox" id="cbSubstanceUseHistory_8" name="cbSubstanceUseHistory_8" className='add-only' value="SubstanceUseHistory_8" />Alcohol and/or Drug Withdrawal;
                        </td>
                        <td className='w-250'>
                            <input type="checkbox" id="cbSubstanceUseHistory_9" name="cbSubstanceUseHistory_9" className='add-only' value="SubstanceUseHistory_9" />Problems caused by gambling;
                        </td>
                    </tr>
                    <tr>
                        <td className='w-250'>
                            <input type="checkbox" id="cbSubstanceUseHistory_10" name="cbSubstanceUseHistory_10" className='add-only' value="SubstanceUseHistory_10" />Trouble stopping any substance;
                        </td>
                        <td className='w-250'>&nbsp;</td>
                        <td className='w-250'>&nbsp;</td>
                    </tr>
                    <tr>
                        <td className='w-250'>
                            <input type="checkbox" id="cbSubstanceUseHistory_12" name="cbSubstanceUseHistory_12" className='add-only' value="SubstanceUseHistory_12" />Other/Describe:
                        </td>
                        <td className='w-250'>&nbsp;</td>
                        <td className='w-250'>&nbsp;</td>
                    </tr>
                    <tr>
                        <td className='w-250'>
                            <input type="text" id="txtcbSubstanceUseHistory_12" name="SubstanceUseHistory_12" className='add-only' />
                        </td>
                        <td className='w-250'>&nbsp;</td>
                        <td className='w-250'>&nbsp;</td>
                    </tr>
                </table>
                <table>
                    <tr>
                        <td className='w-750'><span className='eleHeader'>Substance Use Treatment History:</span> </td>
                    </tr>
                    <tr>
                        <td className='w-250'>
                            <input type="checkbox" id="cbSubstanceUseTreatmentHistory_1" name="cbSubstanceUseTreatmentHistory_1" className='add-only' value="SubstanceUseTreatmentHistory_1" />None;
                        </td>
                        <td className='w-250'>
                            <input type="checkbox" id="cbSubstanceUseTreatmentHistory_2" name="cbSubstanceUseTreatmentHistory_2" className='add-only' value="SubstanceUseTreatmentHistory_2" />Outpatient;
                        </td>
                        <td className='w-250'>
                            <input type="checkbox" id="cbSubstanceUseTreatmentHistory_3" name="cbSubstanceUseTreatmentHistory_3" className='add-only' value="SubstanceUseTreatmentHistory_3" />Intensive Outpatient;
                        </td>
                    </tr>
                    <tr>
                        <td className='w-250'>
                            <input type="checkbox" id="cbSubstanceUseTreatmentHistory_4" name="cbSubstanceUseTreatmentHistory_4" className='add-only' value="SubstanceUseTreatmentHistory_4" />Residential/Inpatient:;
                        </td>
                        <td className='w-250'>
                            <input type="checkbox" id="cbSubstanceUseTreatmentHistory_5" name="cbSubstanceUseTreatmentHistory_5" className='add-only' value="SubstanceUseTreatmentHistory_5" />Detox;
                        </td>
                        <td className='w-250'>&nbsp;</td>
                    </tr>
                    <tr>
                        <td className='w-250'>
                            <input type="checkbox" id="cbSubstanceUseTreatmentHistory_6" name="cbSubstanceUseTreatmentHistory_6" className='add-only' value="SubstanceUseTreatmentHistory_6" />Hx of Drugs Used/Describe͗:
                        </td>
                        <td className='w-250'>&nbsp;</td>
                        <td className='w-250'>&nbsp;</td>
                    </tr>
                    <tr>
                        <td className='w-250'>
                            <input type="text" id="txtSubstanceUseTreatmentHistory_6" name="txtSubstanceUseTreatmentHistory_6" className='add-only' />
                        </td>
                        <td className='w-250'>&nbsp;</td>
                        <td className='w-250'>&nbsp;</td>
                    </tr>
                    <tr>
                        <td className='w-250'>
                            <input type="checkbox" id="cbSubstanceUseTreatmentHistory_7" name="cbSubstanceUseTreatmentHistory_7" className='add-only' value="SubstanceUseTreatmentHistory_6" />Other/Describe:
                        </td>
                        <td className='w-250'>&nbsp;</td>
                        <td className='w-250'>&nbsp;</td>
                    </tr>
                    <tr>
                        <td className='w-250'>
                            <input type="text" id="txtSubstanceUseTreatmentHistory_7" name="txtSubstanceUseTreatmentHistory_7" className='add-only' />
                        </td>
                        <td className='w-250'>&nbsp;</td>
                        <td className='w-250'>&nbsp;</td>
                    </tr>
                </table> 
                <p className='w-750'><strong>(1)</strong></p>
                <table>
                    <tr>
                        <td className='w-375'><span className='eleHeader'>SUBSTANCE TYPE</span> <span className='small'>Include all use in last 30 days.</span> </td>
                        <td className='w-375'><span className='eleHeader'>AGE OF 1ST USE</span> </td>
                    </tr>
                    <tr>
                        <td className='w-375'>
                            <input type="text" id="txtSubstanceType_1" name="txtSubstanceType_1" className='add-only' />
                        </td>
                        <td className='w-375'>
                            <input type="text" id="txtAgeOfFirstUse_1" name="txtAgeOfFirstUse_1" className='add-only' />
                        </td>
                    </tr>
                    <tr>
                        <td className='w-375'><span className='eleHeader'>YEARS IN LIFETIME</span> </td>
                        <td className='w-375'><span className='eleHeader'>DAYS IN PAST 30</span> </td>
                    </tr>
                    <tr>
                        <td className='w-375'>
                            <input type="text" id="txtYearsInLifetime_1" name="txtYearsInLifetime_1" className='add-only' />
                        </td>
                        <td className='w-375'>
                            <input type="text" id="txtDaysInPast_1" name="txtDaysInPast_1" className='add-only' />
                        </td>
                    </tr>
                    <tr>
                        <td className='w-375'><span className='eleHeader'>DAYS SINCE LAST USE</span> </td>
                        <td className='w-375'><span className='eleHeader'>AMOUNT</span> </td>
                    </tr>
                    <tr>
                        <td className='w-375'>
                            <input type="text" id="txtDaysSinceLastUsee_1" name="txtDaysSinceLastUsee_1" className='add-only' />
                        </td>
                        <td className='w-375'>
                            <input type="text" id="txtAmount_1" name="txtAmount_1" className='add-only' />
                        </td>
                    </tr>
                    <tr>
                        <td className='w-750'><span className='eleHeader'>ROUTE OF ADMINISTRATION</span> </td>
                    </tr>
                    <tr>
                        <td className='w-750'>
                            <input type="radio" id="rbRouteOfAdminOral_1" name="rbRouteOfAdmin_1" className='add-only' value="Oral" /> Oral &nbsp;

                            <input type="radio" id="rbRouteOfAdminNasal_1" name="rbRouteOfAdmin_1" className='add-only' value="Nasal" /> Nasal &nbsp;

                            <input type="radio" id="rbRouteOfAdminSmoking_1" name="rbRouteOfAdmin_1" className='add-only' value="Smoking" /> Smoking &nbsp;

                            <input type="radio" id="rbRouteOfAdminNonIv_1" name="rbRouteOfAdmin_1" className='add-only' value="NonIv" /> Non-IV Injxn &nbsp;

                            <input type="radio" id="rbRouteOfAdminIv_1" name="rbRouteOfAdmin_1" className='add-only' value="Iv" />IV
                        </td>
                    </tr>
                </table>

                <p className='w-750'><strong>(2)</strong></p>
                <table>
                    <tr>
                        <td className='w-375'><span className='eleHeader'>SUBSTANCE TYPE</span> <span className='small'>Include all use in last 30 days.</span> </td>
                        <td className='w-375'><span className='eleHeader'>AGE OF 1ST USE</span> </td>
                    </tr>
                    <tr>
                        <td className='w-375'>
                            <input type="text" id="txtSubstanceType_2" name="txtSubstanceType_2" className='add-only' />
                        </td>
                        <td className='w-375'>
                            <input type="text" id="txtAgeOfFirstUse_2" name="txtAgeOfFirstUse_2" className='add-only' />
                        </td>
                    </tr>
                    <tr>
                        <td className='w-375'><span className='eleHeader'>YEARS IN LIFETIME</span> </td>
                        <td className='w-375'><span className='eleHeader'>DAYS IN PAST 30</span> </td>
                    </tr>
                    <tr>
                        <td className='w-375'>
                            <input type="text" id="txtYearsInLifetime_2" name="txtYearsInLifetime_2" className='add-only' />
                        </td>
                        <td className='w-375'>
                            <input type="text" id="txtDaysInPast_2" name="txtDaysInPast_2" className='add-only' />
                        </td>
                    </tr>
                    <tr>
                        <td className='w-375'><span className='eleHeader'>DAYS SINCE LAST USE</span> </td>
                        <td className='w-375'><span className='eleHeader'>AMOUNT</span> </td>
                    </tr>
                    <tr>
                        <td className='w-375'>
                            <input type="text" id="txtDaysSinceLastUsee_2" name="txtDaysSinceLastUsee_2" className='add-only' />
                        </td>
                        <td className='w-375'>
                            <input type="text" id="txtAmount_2" name="txtAmount_2" className='add-only' />
                        </td>
                    </tr>
                    <tr>
                        <td className='w-750'><span className='eleHeader'>ROUTE OF ADMINISTRATION</span> </td>
                    </tr>
                    <tr>
                        <td className='w-750'>
                            <input type="radio" id="rbRouteOfAdminOral_2" name="rbRouteOfAdmin_2" className='add-only' value="Oral" /> Oral &nbsp;

                            <input type="radio" id="rbRouteOfAdminNasal_2" name="rbRouteOfAdmin_2" className='add-only' value="Nasal" /> Nasal &nbsp;

                            <input type="radio" id="rbRouteOfAdminSmoking_2" name="rbRouteOfAdmin_2" className='add-only' value="Smoking" /> Smoking &nbsp;

                            <input type="radio" id="rbRouteOfAdminNonIv_2" name="rbRouteOfAdmin_2" className='add-only' value="NonIv" /> Non-IV Injxn &nbsp;

                            <input type="radio" id="rbRouteOfAdminIv_2" name="rbRouteOfAdmin_2" className='add-only' value="Iv" />IV
                        </td>
                    </tr>
                </table>

                <p className='w-750'><strong>(3)</strong></p>
                <table>
                    <tr>
                        <td className='w-375'><span className='eleHeader'>SUBSTANCE TYPE</span> <span className='small'>Include all use in last 30 days.</span> </td>
                        <td className='w-375'><span className='eleHeader'>AGE OF 1ST USE</span> </td>
                    </tr>
                    <tr>
                        <td className='w-375'>
                            <input type="text" id="txtSubstanceType_3" name="txtSubstanceType_3" className='add-only' />
                        </td>
                        <td className='w-375'>
                            <input type="text" id="txtAgeOfFirstUse_3" name="txtAgeOfFirstUse_3" className='add-only' />
                        </td>
                    </tr>
                    <tr>
                        <td className='w-375'><span className='eleHeader'>YEARS IN LIFETIME</span> </td>
                        <td className='w-375'><span className='eleHeader'>DAYS IN PAST 30</span> </td>
                    </tr>
                    <tr>
                        <td className='w-375'>
                            <input type="text" id="txtYearsInLifetime_3" name="txtYearsInLifetime_3" className='add-only' />
                        </td>
                        <td className='w-375'>
                            <input type="text" id="txtDaysInPast_3" name="txtDaysInPast_3" className='add-only' />
                        </td>
                    </tr>
                    <tr>
                        <td className='w-375'><span className='eleHeader'>DAYS SINCE LAST USE</span> </td>
                        <td className='w-375'><span className='eleHeader'>AMOUNT</span> </td>
                    </tr>
                    <tr>
                        <td className='w-375'>
                            <input type="text" id="txtDaysSinceLastUsee_3" name="txtDaysSinceLastUsee_3" className='add-only' />
                        </td>
                        <td className='w-375'>
                            <input type="text" id="txtAmount_3" name="txtAmount_3" className='add-only' />
                        </td>
                    </tr>
                    <tr>
                        <td className='w-750'><span className='eleHeader'>ROUTE OF ADMINISTRATION</span> </td>
                    </tr>
                    <tr>
                        <td className='w-750'>
                            <input type="radio" id="rbRouteOfAdminOral_3" name="rbRouteOfAdmin_3" className='add-only' value="Oral" /> Oral &nbsp;

                            <input type="radio" id="rbRouteOfAdminNasal_3" name="rbRouteOfAdmin_3" className='add-only' value="Nasal" /> Nasal &nbsp;

                            <input type="radio" id="rbRouteOfAdminSmoking_3" name="rbRouteOfAdmin_3" className='add-only' value="Smoking" /> Smoking &nbsp;

                            <input type="radio" id="rbRouteOfAdminNonIv_3" name="rbRouteOfAdmin_3" className='add-only' value="NonIv" /> Non-IV Injxn &nbsp;

                            <input type="radio" id="rbRouteOfAdminIv_3" name="rbRouteOfAdmin_3" className='add-only' value="Iv" />IV
                        </td>
                    </tr>
                </table>

                <h3>PHYSICAL</h3>
                <p className='w-750'>
                    <strong>PHYSICAL/SOCIAL/EMOTIONAL DEVELOPMENTAL HISTORY: </strong>
                </p>
                <p className='w-750'>
                    <span className='eleHeader'>Any complications during pregnancy:
                    </span>
                    <input type="radio" id="rbAnyComplicationDuringPregnancy_No" name="rbAnyComplicationDuringPregnancy" className='add-only' value="No" /> No; &nbsp;

                    <input type="radio" id="rbAnyComplicationDuringPregnancy_Yes" name="rbAnyComplicationDuringPregnancy" className='add-only' value="Yes" /> Yes &nbsp;

                </p>
                <p className='w-750'>
                    <span className='eleHeader'>Any history of illness/infection/Accident:
                    </span>
                    <input type="radio" id="rbAnyHistoryOfIllness_No" name="rbAnyHistoryOfIllness" className='add-only' value="No" /> No; &nbsp;

                    <input type="radio" id="rbAnyHistoryOfIllness_Yes" name="rbAnyHistoryOfIllness" className='add-only' value="Yes" /> Yes &nbsp;
                </p>
                <p className='w-750'>
                    <span className='eleHeader'>Any medications taking during pregnancy:
                    </span>
                    <input type="radio" id="rbAnyMedicationTakingDuringPregnancy_No" name="rbAnyMedicationTakingDuringPregnancy" className='add-only' value="No" /> No; &nbsp;

                    <input type="radio" id="rbAnyMedicationTakingDuringPregnancy_Yes" name="rbAnyMedicationTakingDuringPregnancy" className='add-only' value="Yes" /> Yes &nbsp;
                </p>
                <p className='w-750'>
                    <span className='eleHeader'>Any substance use (smoking, tobacco, alcohol or drug intake
                        during pregnancy:
                    </span>
                    <input type="radio" id="rbAnySubstanceUseDuringPregnancy_No" name="rbAnySubstanceUseDuringPregnancy" className='add-only' value="No" /> No; &nbsp;

                    <input type="radio" id="rbAnySubstanceUseDuringPregnancy_Yes" name="rbAnySubstanceUseDuringPregnancy" className='add-only' value="Yes" /> Yes &nbsp;
                </p>
                <p className='w-750'>
                    <span className='eleHeader'>Has the client had any prenatal exposure to substances
                    </span>
                    <input type="radio" id="rbHasTheClientHadAnyParentalExposureToSubstance_No" name="rbHasTheClientHadAnyParentalExposureToSubstance" className='add-only' value="No" /> No; &nbsp;

                    <input type="radio" id="rbHasTheClientHadAnyParentalExposureToSubstance_Yes" name="rbHasTheClientHadAnyParentalExposureToSubstance" className='add-only' value="Yes" /> Yes &nbsp;
                </p>
                <p className='w-750'>
                    <span className='eleHeader'>Was delivery normal? </span>
                    <input type="radio" id="rbWasdeliveryNormal_No" name="rbWasdeliveryNormal" className='add-only' value="No" /> No; &nbsp;

                    <input type="radio" id="rbWasdeliveryNormal_Yes" name="rbWasdeliveryNormal" className='add-only' value="Yes" /> Yes &nbsp;
                </p>
                <p className='w-750'>
                    <span className='eleHeader'>Birth Weight?</span>
                    <input type="text" id="txtLbs" name="txtLbs" className='add-only w-100 custom-add-only' /> Lbs.  &nbsp;

                    <input type="text" id="txtOz" name="txtOz" className='add-only w-100 custom-add-only' /> oz. &nbsp;

                    <input type="checkbox" id="cbBirthWeightUnknown" name="cbBirthWeightUnknown" className='add-only' value="BirthWeightUnknown" /> unknown
                </p>

                <p className='w-750'>
                    <span className='eleHeader'>Did the child experience any issues immediately after birth?</span>
                    <input type="radio" id="rbDidTheChildExperienceAnyIssuesImmediatlyAfterBirth_No" name="rbDidTheChildExperienceAnyIssuesImmediatlyAfterBirth" className='add-only' value="No" /> No; &nbsp;

                    <input type="radio" id="rbDidTheChildExperienceAnyIssuesImmediatlyAfterBirth_Yes" name="rbDidTheChildExperienceAnyIssuesImmediatlyAfterBirth" className='add-only' value="Yes" /> Yes &nbsp;,
                </p>
                <p className='w-750'>
                    If Yes explain?
                    <textarea id="txtDidTheChildExperienceAnyIssuesImmediatlyAfterBirthIfYesExplain" name="txtDidTheChildExperienceAnyIssuesImmediatlyAfterBirthIfYesExplain" className='add-only'></textarea>
                </p>
                <p className='w-750'>
                    <span className='eleHeader'>Did the child reach all developmental milestones within normal range?</span>
                    <input type="radio" id="rbDidTheChildReachAllDevelopmentMilestoneWithinNormalRange_No" name="rbDidTheChildReachAllDevelopmentMilestoneWithinNormalRange" className='add-only' value="No" /> No; &nbsp;

                    <input type="radio" id="rbDidTheChildReachAllDevelopmentMilestoneWithinNormalRange_Yes" name="rbDidTheChildReachAllDevelopmentMilestoneWithinNormalRange" className='add-only' value="Yes" /> Yes &nbsp;,
                </p>
                <p className='w-750'>
                    If Yes explain?
                    <textarea id="txtDidTheChildReachAllDevelopmentMilestoneWithinNormalRangeIfYesExplain" name="txtDidTheChildReachAllDevelopmentMilestoneWithinNormalRangeIfYesExplain" className='add-only'></textarea>

                </p>
                <p className='w-750'>
                    <strong>V. CURRENT MEDICAL CONDITIONS</strong>
                    <span className='small'>(Check all that apply)</span>
                </p>

                <table>
                    <tr>
                        <td className='w-250'>
                            <input type="checkbox" id="cbMedicalConditions_1" name="cbMedicalConditions_1" className='add-only' value="MedicalConditions_1" />Pregnant
                        </td>
                        <td className='w-250'>&nbsp;</td>
                        <td className='w-250'>&nbsp;</td>
                    </tr>
                    <tr>
                        <td className='w-250'>
                            <input type="checkbox" id="cbMedicalConditions_2" name="cbMedicalConditions_2" className='add-only' value="MedicalConditions_2" />Due date:
                        </td>
                        <td className='w-250'>&nbsp;</td>
                        <td className='w-250'>&nbsp;</td>
                    </tr>
                    <tr>
                        <td className='w-250'>
                            <input type="date" id="txtMedicalConditions_2" name="txtMedicalConditions_2" className='add-only' />
                        </td>
                        <td className='w-250'>&nbsp;</td>
                        <td className='w-250'>&nbsp;</td>
                    </tr>
                    <tr>
                        <td className='w-250'>
                            <input type="checkbox" id="cbMedicalConditions_3" name="cbMedicalConditions_3" className='add-only' value="MedicalConditions_3" />Prenatal care
                        </td>
                        <td className='w-250'>&nbsp;</td>
                        <td className='w-250'>&nbsp;</td>
                    </tr>
                    <tr>
                        <td className='w-250'>
                            <input type="text" id="txtMedicalConditions_3" name="txtMedicalConditions_3" className='add-only' />
                        </td>
                        <td className='w-250'>&nbsp;</td>
                        <td className='w-250'>&nbsp;</td>
                    </tr>
                    <tr>
                        <td className='w-250'>
                            <input type="checkbox" id="cbMedicalConditions_4" name="cbMedicalConditions_4" className='add-only' value="MedicalConditions_4" />None Reported
                        </td>
                        <td className='w-250'>
                            <input type="checkbox" id="cbMedicalConditions_5" name="cbMedicalConditions_5" className='add-only' value="MedicalConditions_5" />Congestive Heart Failure
                        </td>
                        <td className='w-250'>
                            <input type="checkbox" id="cbMedicalConditions_6" name="cbMedicalConditions_6" className='add-only' value="MedicalConditions_6" />Asthma
                        </td>
                    </tr>
                    <tr>
                        <td className='w-250'>
                            <input type="checkbox" id="cbMedicalConditions_7" name="cbMedicalConditions_7" className='add-only' value="MedicalConditions_7" />Seizure
                        </td>
                        <td className='w-250'>
                            <input type="checkbox" id="cbMedicalConditions_8" name="cbMedicalConditions_8" className='add-only' value="MedicalConditions_8" />Cancer
                        </td>
                        <td className='w-250'>
                            <input type="checkbox" id="cbMedicalConditions_9" name="cbMedicalConditions_9" className='add-only' value="MedicalConditions_9" />Underweight
                        </td>
                    </tr>
                    <tr>
                        <td className='w-250'>
                            <input type="checkbox" id="cbMedicalConditions_10" name="cbMedicalConditions_10" className='add-only' value="MedicalConditions_10" />High Blood Pressure
                        </td>
                        <td className='w-250'>
                            <input type="checkbox" id="cbMedicalConditions_11" name="cbMedicalConditions_11" className='add-only' value="MedicalConditions_11" />Stroke
                        </td>
                        <td className='w-250'>
                            <input type="checkbox" id="cbMedicalConditions_12" name="cbMedicalConditions_12" className='add-only' value="MedicalConditions_12" />Emphysema
                        </td>
                    </tr>
                    <tr>
                        <td className='w-250'>
                            <input type="checkbox" id="cbMedicalConditions_13" name="cbMedicalConditions_13" className='add-only' value="MedicalConditions_13" />Cirrhosis
                        </td>
                        <td className='w-250'>
                            <input type="checkbox" id="cbMedicalConditions_14" name="cbMedicalConditions_14" className='add-only' value="MedicalConditions_14" />Chronic Pain
                        </td>
                        <td className='w-250'>
                            <input type="checkbox" id="cbMedicalConditions_15" name="cbMedicalConditions_15" className='add-only' value="MedicalConditions_15" />Overweight
                        </td>
                    </tr>
                    <tr>
                        <td className='w-250'>
                            <input type="checkbox" id="cbMedicalConditions_16" name="cbMedicalConditions_16" className='add-only' value="MedicalConditions_16" />Heart Disease
                        </td>
                        <td className='w-250'>
                            <input type="checkbox" id="cbMedicalConditions_17" name="cbMedicalConditions_17" className='add-only' value="MedicalConditions_17" />Diabetes
                        </td>
                        <td className='w-250'>
                            <input type="checkbox" id="cbMedicalConditions_18" name="cbMedicalConditions_18" className='add-only' value="MedicalConditions_18" />Epilepsy
                        </td>
                    </tr>
                    <tr>
                        <td className='w-250'>
                            <input type="checkbox" id="cbMedicalConditions_19" name="cbMedicalConditions_19" className='add-only' value="MedicalConditions_19" />Digestive Problems
                        </td>
                        <td className='w-250'>
                            <input type="checkbox" id="cbMedicalConditions_20" name="cbMedicalConditions_20" className='add-only' value="MedicalConditions_20" />Thyroid Disease
                        </td>
                        <td className='w-250'>
                            <input type="checkbox" id="cbMedicalConditions_21" name="cbMedicalConditions_21" className='add-only' value="MedicalConditions_21" />Sexually Transmitted Dz.
                        </td>
                    </tr>
                    <tr>
                        <td className='w-250'>
                            <input type="checkbox" id="cbMedicalConditions_22" name="cbMedicalConditions_22" className='add-only' value="MedicalConditions_22" />Other/Describe:
                        </td>
                        <td className='w-250'>&nbsp;</td>
                        <td className='w-250'>&nbsp;</td>
                    </tr>
                    <tr>
                        <td className='w-250'>
                            <input type="text" id="txtMedicalConditions_22" name="txtMedicalConditions_22" className='add-only' />
                        </td>
                        <td className='w-250'>&nbsp;</td>
                        <td className='w-250'>&nbsp;</td>
                    </tr>
                </table>
                <table>

                    <tr>
                        <td className='w-375'><span className='eleHeader'>Any difficulty with speech:</span> </td>
                        <td className='w-375'><span className='eleHeader'>Any difficulty with hearing:</span></td>
                    </tr>
                    <tr>
                        <td className='w-375'>
                            <input type="radio" id="rbAnydifficultyWithSpeechYes_1" name="rbAnydifficultyWithSpeechYes_1" className='add-only' value="Yes" /> Yes &nbsp;

                            <input type="radio" id="rbAnydifficultyWithSpeechYesNo_1" name="rbAnydifficultyWithSpeechNo_1" className='add-only' value="No" /> No
                        </td>
                        <td className='w-375'>
                            <input type="radio" id="rbAnydifficultyWithHearingYes_1" name="rbAnydifficultyWithHearingYes_1" className='add-only' value="Yes" /> Yes &nbsp;

                            <input type="radio" id="rbAnydifficultyWithHearingNo_1" name="rbAnydifficultyWithHearingNo_1" className='add-only' value="No" /> No
                        </td>
                    </tr>
                    <tr>
                        <td className='w-375'>
                            <span className='eleHeader'>Any difficulty with vision:</span>
                            <input type="radio" id="rbAnydifficultyWithVisionYes_1" name="rbAnydifficultyWithVisionYes_1" className='add-only' value="Yes" /> Yes &nbsp;

                            <input type="radio" id="rbAnydifficultyWithVisionNo_1" name="rbAnydifficultyWithVisionNo_1" className='add-only' value="No" /> No
                            </td> 
                    </tr>
                </table>
                <p className='w-750'>
                    <span className='eleHeader'>11. IMMUNIZATION HISTORY– </span>
                    Has recipient had or been immunized for the following diseases? (Please check)
                </p>
                <table>
                    <tr>
                        <td className='w-250'>
                            <input type="checkbox" id="cbImmunizationHistory_1" name="cbImmunizationHistory_1" className='add-only' value="ImmunizationHistory_1" />Chicken Pox
                        </td>
                        <td className='w-250'>
                            <input type="checkbox" id="cbImmunizationHistory_2" name="cbImmunizationHistory_2" className='add-only' value="ImmunizationHistory_2" />German Measles
                        </td>
                        <td className='w-250'>
                            <input type="checkbox" id="cbImmunizationHistory_3" name="cbImmunizationHistory_3" className='add-only' value="ImmunizationHistory_3" />Measles
                        </td>
                    </tr>
                    <tr>
                        <td className='w-250'>
                            <input type="checkbox" id="cbImmunizationHistory_4" name="cbImmunizationHistory_4" className='add-only' value="ImmunizationHistory_4" />Mumps
                        </td>
                        <td className='w-250'>
                            <input type="checkbox" id="cbImmunizationHistory_5" name="cbImmunizationHistory_5" className='add-only' value="ImmunizationHistory_5" />Small Pox
                        </td>
                        <td className='w-250'>
                            <input type="checkbox" id="cbImmunizationHistory_6" name="cbImmunizationHistory_6" className='add-only' value="ImmunizationHistory_6" />Polio
                        </td>
                    </tr>
                    <tr>
                        <td className='w-250'>
                            <input type="checkbox" id="cbImmunizationHistory_7" name="cbImmunizationHistory_7" className='add-only' value="ImmunizationHistory_7" />Diphtheria
                        </td>
                        <td className='w-250'>
                            <input type="checkbox" id="cbImmunizationHistory_8" name="cbImmunizationHistory_8" className='add-only' value="ImmunizationHistory_8" />Tetanus
                        </td>
                        <td className='w-250'>
                            <input type="checkbox" id="cbImmunizationHistory_9" name="cbImmunizationHistory_9" className='add-only' value="ImmunizationHistory_9" />Hepatitis B
                        </td>
                    </tr>
                    <tr>
                        <td className='w-250'>
                            <input type="checkbox" id="cbImmunizationHistory_10" name="cbImmunizationHistory_10" className='add-only' value="ImmunizationHistory_10" />Other:
                        </td>
                        <td className='w-250'>&nbsp;</td>
                        <td className='w-250'>&nbsp;</td>
                    </tr>
                    <tr>
                        <td className='w-250'>
                            <input type="text" id="txtImmunizationHistory_10" name="txtImmunizationHistory_10" className='add-only' />
                        </td>
                        <td className='w-250'>&nbsp;</td>
                        <td className='w-250'>&nbsp;</td>
                    </tr>
                    <tr>
                        <td className='w-750'>
                            <input type="checkbox" id="cbImmunizationWithinThePastYear" name="cbImmunizationWithinThePastYear" className='add-only' value="ImmunizationWithinThePastYear" />Immunizations within the past year:
                        </td>
                    </tr>
                    <tr>
                        <td className='w-750'>
                            <input type="text" id="txtImmunizationWithinThePastYear" name="txtImmunizationWithinThePastYear" className='add-only' />
                        </td>
                    </tr>
                </table>

                <p className='w-750'>
                    <strong>VI. CURRENT & PAST MEDICATIONs</strong>
                    <span className='small'>(Including non-psychotropic medications)</span>
                </p>
                <p className='w-750'><strong>(1)</strong></p>
                <table>
                    <tr>
                        <td className='w-375'><span className='eleHeader'>Medication Name</span> </td>
                        <td className='w-375'>&nbsp;</td>
                    </tr>
                    <tr>
                        <td className='w-375'>
                            <input type="text" id="txtMedicationName_1" name="txtMedicationName_1" className='add-only' />
                        </td>
                        <td className='w-375'>&nbsp;</td>
                    </tr>
                    <tr>
                        <td className='w-375'><span className='eleHeader'>Dose</span> </td>
                        <td className='w-375'><span className='eleHeader'>Freq.</span> </td>
                    </tr>
                    <tr>
                        <td className='w-375'>
                            <input type="text" id="txtDose_1" name="txtDose_1" className='add-only' />
                        </td>
                        <td className='w-375'>
                            <input type="text" id="txtFreq_1" name="txtFreq_1" className='add-only' />
                        </td>
                    </tr>
                    <tr>
                        <td className='w-375'><span className='eleHeader'>Route</span> </td>
                        <td className='w-375'><span className='eleHeader'>Current</span> </td>
                    </tr>
                    <tr>
                        <td className='w-375'>
                            <input type="text" id="txtRoute_1" name="txtRoute_1" className='add-only' />
                        </td>
                        <td className='w-375'>
                            <input type="radio" id="rbCurrentYes_1" name="rbCurrent_1" className='add-only' value="Yes" /> Yes &nbsp;

                            <input type="radio" id="rbCurrentNo_1" name="rbCurrent_1" className='add-only' value="No" /> No
                        </td>
                    </tr>
                    <tr>
                        <td className='w-750'>
                            <p className='w-750'><span className='eleHeader'>COMMENTS</span> <span className='small'>(Reason Prescribed/Response, etc.)</span> </p>
                            <textarea id="txtComments_1" name="txtComments_1" className='add-only'></textarea>
                        </td>
                    </tr>
                </table>

                <p className='w-750'><strong>(2)</strong></p>
                <table>
                    <tr>
                        <td className='w-375'><span className='eleHeader'>Medication Name</span> </td>
                        <td className='w-375'>&nbsp;</td>
                    </tr>
                    <tr>
                        <td className='w-375'>
                            <input type="text" id="txtMedicationName_2" name="txtMedicationName_2" className='add-only' />
                        </td>
                        <td className='w-375'>&nbsp;</td>
                    </tr>
                    <tr>
                        <td className='w-375'><span className='eleHeader'>Dose</span> </td>
                        <td className='w-375'><span className='eleHeader'>Freq.</span> </td>
                    </tr>
                    <tr>
                        <td className='w-375'>
                            <input type="text" id="txtDose_2" name="txtDose_2" className='add-only' />
                        </td>
                        <td className='w-375'>
                            <input type="text" id="txtFreq_2" name="txtFreq_2" className='add-only' />
                        </td>
                    </tr>
                    <tr>
                        <td className='w-375'><span className='eleHeader'>Route</span> </td>
                        <td className='w-375'><span className='eleHeader'>Current</span> </td>
                    </tr>
                    <tr>
                        <td className='w-375'>
                            <input type="text" id="txtRoute_2" name="txtRoute_2" className='add-only' />
                        </td>
                        <td className='w-375'>
                            <input type="radio" id="rbCurrentYes_2" name="rbCurrent_2" className='add-only' value="Yes" /> Yes &nbsp;

                            <input type="radio" id="rbCurrentNo_2" name="rbCurrent_2" className='add-only' value="No" /> No
                        </td>
                    </tr>
                    <tr>
                        <td className='w-750'>
                            <p className='w-750'><span className='eleHeader'>COMMENTS</span> <span className='small'>(Reason Prescribed/Response, etc.)</span> </p>
                            <textarea id="txtComments_2" name="txtComments_2" className='add-only'></textarea>
                        </td>
                    </tr>
                </table>

                <p className='w-750'><strong>(3)</strong></p>
                <table>
                    <tr>
                        <td className='w-375'><span className='eleHeader'>Medication Name</span> </td>
                        <td className='w-375'>&nbsp;</td>
                    </tr>
                    <tr>
                        <td className='w-375'>
                            <input type="text" id="txtMedicationName_3" name="txtMedicationName_3" className='add-only' />
                        </td>
                        <td className='w-375'>&nbsp;</td>
                    </tr>
                    <tr>
                        <td className='w-375'><span className='eleHeader'>Dose</span> </td>
                        <td className='w-375'><span className='eleHeader'>Freq.</span> </td>
                    </tr>
                    <tr>
                        <td className='w-375'>
                            <input type="text" id="txtDose_3" name="txtDose_3" className='add-only' />
                        </td>
                        <td className='w-375'>
                            <input type="text" id="txtFreq_3" name="txtFreq_3" className='add-only' />
                        </td>
                    </tr>
                    <tr>
                        <td className='w-375'><span className='eleHeader'>Route</span> </td>
                        <td className='w-375'><span className='eleHeader'>Current</span> </td>
                    </tr>
                    <tr>
                        <td className='w-375'>
                            <input type="text" id="txtRoute_3" name="txtRoute_3" className='add-only' />
                        </td>
                        <td className='w-375'>
                            <input type="radio" id="rbCurrentYes_3" name="rbCurrent_3" className='add-only' value="Yes" /> Yes &nbsp;

                            <input type="radio" id="rbCurrentNo_3" name="rbCurrent_3" className='add-only' value="No" /> No
                        </td>
                    </tr>
                    <tr>
                        <td className='w-750'>
                            <p className='w-750'><span className='eleHeader'>COMMENTS</span> <span className='small'>(Reason Prescribed/Response, etc.)</span> </p>
                            <textarea id="txtComments_3" name="txtComments_3" className='add-only'></textarea>
                        </td>
                    </tr>
                </table>

                <p className='w-750'><strong>(4)</strong></p>
                <table>
                    <tr>
                        <td className='w-375'><span className='eleHeader'>Medication Name</span> </td>
                        <td className='w-375'>&nbsp;</td>
                    </tr>
                    <tr>
                        <td className='w-375'>
                            <input type="text" id="txtMedicationName_4" name="txtMedicationName_4" className='add-only' />
                        </td>
                        <td className='w-375'>&nbsp;</td>
                    </tr>
                    <tr>
                        <td className='w-375'><span className='eleHeader'>Dose</span> </td>
                        <td className='w-375'><span className='eleHeader'>Freq.</span> </td>
                    </tr>
                    <tr>
                        <td className='w-375'>
                            <input type="text" id="txtDose_4" name="txtDose_4" className='add-only' />
                        </td>
                        <td className='w-375'>
                            <input type="text" id="txtFreq_4" name="txtFreq_4" className='add-only' />
                        </td>
                    </tr>
                    <tr>
                        <td className='w-375'><span className='eleHeader'>Route</span> </td>
                        <td className='w-375'><span className='eleHeader'>Current</span> </td>
                    </tr>
                    <tr>
                        <td className='w-375'>
                            <input type="text" id="txtRoute_4" name="txtRoute_4" className='add-only' />
                        </td>
                        <td className='w-375'>
                            <input type="radio" id="rbCurrentYes_4" name="rbCurrent_4" className='add-only' value="Yes" /> Yes &nbsp;

                            <input type="radio" id="rbCurrentNo_4" name="rbCurrent_4" className='add-only' value="No" /> No
                        </td>
                    </tr>
                    <tr>
                        <td className='w-750'>
                            <p className='w-750'><span className='eleHeader'>COMMENTS</span> <span className='small'>(Reason Prescribed/Response, etc.)</span> </p>
                            <textarea id="txtComments_4" name="txtComments_4" className='add-only'></textarea>
                        </td>
                    </tr>
                </table>

                <p className='w-750'><span className='eleHeader'>VII. ALLERGIES</span> </p>
                <p className='w-750'>

                    <input type="checkbox" id="cbAllergies_Food" name="cbAllergies_Food" className='add-only' value="Allergies_Food" />No Reported Drug or Food Allergies;
                </p>
                <p className='w-750'>

                    <input type="checkbox" id="cbAllergies_Other" name="cbAllergies_Other" className='add-only' value="Allergies_Other" />Other/Describe:
                    <textarea id="txtAllergies_OtherDescribe" name="txtAllergies_OtherDescribe" className='add-only'></textarea>
                </p>

                <p className='w-750'>
                    <span className='eleHeader'>VIII. PRIMARY CARE PHYSICIAN</span>
                </p>

                <table>
                    <tr>
                        <td className='w-250'><strong>NAME</strong></td>
                        <td className='w-250'><strong>PHONE</strong></td>
                        <td className='w-250'><strong>FAX </strong></td>
                    </tr>
                    <tr>
                        <td className='w-250'>
                            <input type="text" id="txtPhysicianName" name="txtPhysicianName" className='add-only' />
                        </td>
                        <td className='w-250'>
                            <input type="text" id="txtPhysicianPhone" name="txtPhysicianPhone" className='add-only' />
                        </td>
                        <td className='w-250'>
                            <input type="text" id="txtPhysicianFax" name="txtPhysicianFax" className='add-only' />
                        </td>
                    </tr>
                </table>

                <p className='w-750'>
                    <span className='eleHeader'>IX. ADDITIONAL MEDICAL HISTORY</span>
                    <span className='small'>(Diagnosis, Hospitalizations, Surgery, labs values, status of
                        conditions, etc.)
                    </span>
                    <textarea id="txtAdditionalMedicalHistory" name="txtAdditionalMedicalHistory" className='add-only'></textarea>
                </p>

                <h3>SOCIAL</h3>
                <p className='w-750'>
                    <strong>X. LEGAL STATUS</strong>
                </p>
                <p className='w-750'>
                    <span className='eleHeader'>Current Legal Status:</span>
                </p>
                <table>
                    <tr>
                        <td className='w-187'>
                            <input type="checkbox" id="cbCurrentLegalStatus_1" name="cbCurrentLegalStatus_1" className='add-only' value="CurrentLegalStatus_1" />
                            None;
                        </td>
                        <td className='w-187'>
                            <input type="checkbox" id="cbCurrentLegalStatus_2" name="cbCurrentLegalStatus_2" className='add-only' value="CurrentLegalStatus_2" />
                            Probation;
                        </td>
                        <td className='w-187'>
                            <input type="checkbox" id="cbCurrentLegalStatus_3" name="cbCurrentLegalStatus_3" className='add-only' value="CurrentLegalStatus_3" />
                            Charges Pending;
                        </td>
                        <td className='w-187'>
                            <input type="checkbox" id="cbCurrentLegalStatus_4" name="cbCurrentLegalStatus_4" className='add-only' value="CurrentLegalStatus_4" />
                            DCFS;
                        </td>
                    </tr>
                    <tr>
                        <td className='w-187'>
                            <input type="checkbox" id="cbCurrentLegalStatus_5" name="cbCurrentLegalStatus_5" className='add-only' value="CurrentLegalStatus_5" />
                            OJJ;
                        </td>
                        <td className='w-187'>&nbsp;</td>
                        <td className='w-187'>&nbsp;</td>
                        <td className='w-187'>&nbsp;</td>
                    </tr>
                    <tr>
                        <td className='w-187'>
                            <input type="checkbox" id="cbCurrentLegalStatus_6" name="cbCurrentLegalStatus_6" className='add-only' value="CurrentLegalStatus_6" />
                            Other;
                        </td>
                        <td className='w-187'>&nbsp;</td>
                        <td className='w-187'>&nbsp;</td>
                        <td className='w-187'>&nbsp;</td>
                    </tr>
                    <tr>
                        <td className='w-187'>
                            <input type="text" id="txtCurrentLegalStatus_6" name="txtCurrentLegalStatus_6" className='add-only' />
                        </td>
                        <td className='w-187'>&nbsp;</td>
                        <td className='w-187'>&nbsp;</td>
                        <td className='w-187'>&nbsp;</td>
                    </tr>
                </table>
                <p className='w-750'>
                    <strong>Comment/Detail:</strong>
                    <textarea id="txtCurrentLegalStatusComment" name="txtCurrentLegalStatusComment" className='add-only'></textarea>
                </p>

                <p className='w-750'><span className='eleHeader'>Past Legal Status:</span></p>
                <table>
                    <tr>
                        <td className='w-187'>
                            <input type="checkbox" id="cbPastLegalStatus_1" name="cbPastLegalStatus_1" className='add-only' value="PastLegalStatus_1" />
                            None;
                        </td>
                        <td className='w-187'>
                            <input type="checkbox" id="cbPastLegalStatus_2" name="cbPastLegalStatus_2" className='add-only' value="PastLegalStatus_2" />
                            DCFS;
                        </td>
                        <td className='w-187'>
                            <input type="checkbox" id="cbPastLegalStatus_3" name="cbPastLegalStatus_3" className='add-only' value="PastLegalStatus_3" />
                            OJJ;
                        </td>
                        <td className='w-187'>&nbsp;</td>
                    </tr>
                    <tr>
                        <td className='w-187'>
                            <input type="checkbox" id="cbPastLegalStatus_5" name="cbPastLegalStatus_5" className='add-only' value="PastLegalStatus_5" />Other;
                        </td>
                        <td className='w-187'>&nbsp;</td>
                        <td className='w-187'>&nbsp;</td>
                        <td className='w-187'>&nbsp;</td>
                    </tr>
                    <tr>
                        <td className='w-187'>
                            <input type="text" id="txtPastLegalStatus_5" name="txtPastLegalStatus_5" className='add-only' />
                        </td>
                        <td className='w-187'>&nbsp;</td>
                        <td className='w-187'>&nbsp;</td>
                        <td className='w-187'>&nbsp;</td>
                    </tr>
                </table>
                <p className='w-750'>
                    <strong>Comment/Detail:</strong>
                    <textarea id="txtPastLegalStatusComment" name="txtPastLegalStatusComment" className='add-only'></textarea>
                </p>

                <p className='w-750'>
                    <strong>XI. FAMILY HISTORY </strong>
                    <span className='small'>(relationship status with relatives, family involvement in treatment, and living status of significant relatives):</span>
                </p>
                <table>
                    <tr>
                        <td className='w-750'><span className='eleHeader'>Custodial Status:</span> </td>
                    </tr>
                    <tr>
                        <td className='w-187'>
                            <input type="checkbox" id="cbCustodialStatus_1" name="cbCustodialStatus_1" className='add-only' value="CustodialStatus_1" />Independent Adult;
                        </td>
                        <td className='w-187'>
                            <input type="checkbox" id="cbCustodialStatus_2" name="cbCustodialStatus_2" className='add-only' value="CustodialStatus_2" />Biological Father;
                        </td>
                        <td className='w-187'>
                            <input type="checkbox" id="cbCustodialStatus_3" name="cbCustodialStatus_3" className='add-only' value="CustodialStatus_3" />Biological Mother;
                        </td>
                        <td className='w-187'>
                            <input type="checkbox" id="cbCustodialStatus_4" name="cbCustodialStatus_4" className='add-only' value="CustodialStatus_4" />Joint Biological Parents;
                        </td>
                    </tr>
                    <tr>
                        <td className='w-187'>
                            <input type="checkbox" id="cbCustodialStatus_5" name="cbCustodialStatus_5" className='add-only' value="CustodialStatus_5" />Gov't/Judicial;
                        </td>
                        <td className='w-187'>&nbsp;</td>
                        <td className='w-187'>&nbsp;</td>
                        <td className='w-187'>&nbsp;</td>
                    </tr>
                    <tr>
                        <td className='w-187'>
                            <input type="checkbox" id="cbCustodialStatus_6" name="cbCustodialStatus_6" className='add-only' value="CustodialStatus_6" />Other:
                        </td>
                        <td className='w-187'>&nbsp;</td>
                        <td className='w-187'>&nbsp;</td>
                        <td className='w-187'>&nbsp;</td>
                    </tr>
                    <tr>
                        <td className='w-187'>
                            <input type="text" id="txtCustodialStatus_6" name="txtCustodialStatus_6" className='add-only' />
                        </td>
                        <td className='w-187'>&nbsp;</td>
                        <td className='w-187'>&nbsp;</td>
                        <td className='w-187'>&nbsp;</td>
                    </tr>
                    <tr>
                        <td className='w-750'>Is Parents/Guardian willing to participate in services: </td>
                    </tr>
                    <tr>
                        <td className='w-750'>
                            <input type="radio" id="rbIsParentsGuardianWillingToParticipateInServicesYes_1" name="rbIsParentsGuardianWillingToParticipateInServicesYes_1" className='add-only' value="Yes" /> Yes &nbsp;

                            <input type="radio" id="rbIsParentsGuardianWillingToParticipateInServicesNo_1" name="rbIsParentsGuardianWillingToParticipateInServicesNo_1" className='add-only' value="No" /> No
                        </td>
                    </tr>
                </table>
                <p className='w-750'>
                    <span className='eleHeader'>Parents/Guardian Preferences:</span>
                    <input type="text" id="txtParentsGuardianPreferences" name="txtParentsGuardianPreferences" className='add-only' />
                    <span className='eleHeader'>Parents/Guardian Strengths:</span>
                    <input type="text" id="txtParentsGuardianStrengths" name="txtParentsGuardianStrengths" className='add-only' />
                </p>
                <table>
                    <tr>
                        <td className='w-750'><span className='eleHeader'>Adverse Circumstances in Family of Origin:</span> </td>
                    </tr>
                    <tr>
                        <td className='w-187'>
                            <input type="checkbox" id="cbAdverseCircumstances_1" name="cbAdverseCircumstances_1" className='add-only' value="AdverseCircumstances_1" />N/A;
                        </td>
                        <td className='w-187'>
                            <input type="checkbox" id="cbAdverseCircumstances_2" name="cbAdverseCircumstances_2" className='add-only' value="AdverseCircumstances_2" />Poverty;
                        </td>
                        <td className='w-187'>
                            <input type="checkbox" id="cbAdverseCircumstances_3" name="cbAdverseCircumstances_3" className='add-only' value="AdverseCircumstances_3" />Criminal Behavioral;
                        </td>
                        <td className='w-187'>
                            <input type="checkbox" id="cbAdverseCircumstances_4" name="cbAdverseCircumstances_4" className='add-only' value="AdverseCircumstances_4" />Mental Illness;
                        </td>
                    </tr>
                    <tr>
                        <td className='w-187'>
                            <input type="checkbox" id="cbAdverseCircumstances_5" name="cbAdverseCircumstances_5" className='add-only' value="AdverseCircumstances_5" />Substance Use;
                        </td>
                        <td className='w-187'>
                            <input type="checkbox" id="cbAdverseCircumstances_6" name="cbAdverseCircumstances_6" className='add-only' value="AdverseCircumstances_6" />Abuse;
                        </td>
                        <td className='w-187'>
                            <input type="checkbox" id="cbAdverseCircumstances_7" name="cbAdverseCircumstances_7" className='add-only' value="AdverseCircumstances_7" />Neglect;
                        </td>
                        <td className='w-187'>
                            <input type="checkbox" id="cbAdverseCircumstances_8" name="cbAdverseCircumstances_8" className='add-only' value="AdverseCircumstances_8" />Domestic Violence;
                        </td>
                    </tr>
                    <tr>
                        <td className='w-187'>
                            <input type="checkbox" id="cbAdverseCircumstances_9" name="cbAdverseCircumstances_9" className='add-only' value="AdverseCircumstances_9" />Violence;
                        </td>
                        <td className='w-187'>
                            <input type="checkbox" id="cbAdverseCircumstances_10" name="cbAdverseCircumstances_10" className='add-only' value="AdverseCircumstances_10" />Trauma;
                        </td>
                        <td className='w-187'>&nbsp;</td>
                        <td className='w-187'>&nbsp;</td>
                    </tr>
                    <tr>
                        <td className='w-187'>
                            <input type="checkbox" id="cbAdverseCircumstances_12" name="cbAdverseCircumstances_12" className='add-only' value="AdverseCircumstances_12" />Other/Describe:
                        </td>
                        <td className='w-187'>&nbsp;</td>
                        <td className='w-187'>&nbsp;</td>
                        <td className='w-187'>&nbsp;</td>
                    </tr>
                    <tr>
                        <td className='w-187'>
                            <input type="text" id="txtAdverseCircumstances_12" name="txtAdverseCircumstances_12" className='add-only' />
                        </td>
                        <td className='w-187'>&nbsp;</td>
                        <td className='w-187'>&nbsp;</td>
                        <td className='w-187'>&nbsp;</td>
                    </tr>
                </table>
                <p className='w-750'>
                    <span className='eleHeader'>How does the client get along with family members?</span>
                    <input type="text" id="txtHowDoesClientGetAlongWithFamily" name="txtHowDoesClientGetAlongWithFamily" className='add-only' />
                </p>
                <p className='w-750'>
                    <span className='eleHeader'>Any difficulty with any family members:</span>
                    <input type="radio" id="rbAnyDifficultyWithAnyFamilyMembers_No" name="rbAnyDifficultyWithAnyFamilyMembers" className='add-only' value="No" /> No &nbsp;

                    <input type="radio" id="rbAnyDifficultyWithAnyFamilyMembers_Yes" name="rbAnyDifficultyWithAnyFamilyMembers" className='add-only' value="Yes" /> Yes &nbsp;

                    <input type="text" id="txtAnyDifficultyWithAnyFamilyMembers" name="txtAnyDifficultyWithAnyFamilyMembers" className='add-only' />
                </p>
                <p className='w-750'>
                    <span className='eleHeader'>Any stressors in the family:</span>
                    <input type="radio" id="rbAnyStressorsInTheFamily_No" name="rbAnyStressorsInTheFamily" className='add-only' value="No" /> No &nbsp;

                    <input type="radio" id="rbAnyStressorsInTheFamily_Yes" name="rbAnyStressorsInTheFamily" className='add-only' value="Yes" /> Yes &nbsp;

                    <input type="text" id="txtAnyStressorsInTheFamily" name="txtAnyStressorsInTheFamily" className='add-only' />
                </p>
                <p className='w-750'>
                    <span className='eleHeader'>Summarize family history and child-rearing practices:</span>
                    <input type="text" id="txtSummarizeFamilyHistoryAndChildRearingPractices" name="txtSummarizeFamilyHistoryAndChildRearingPractices" className='add-only' />
                </p>

                <p className='w-750'><strong>XII. TRAUMA HISTORY</strong></p>
                <table>
                    <tr>
                        <td className='w-750'><span className='eleHeader'>History of Trauma:</span> </td>
                    </tr>
                    <tr>
                        <td className='w-187'>
                            <input type="checkbox" id="cbHistoryTrauma_1" name="cbHistoryTrauma_1" className='add-only' value="HistoryTrauma_1" />
                            None;
                        </td>
                        <td className='w-187'>
                            <input type="checkbox" id="cbHistoryTrauma_2" name="cbHistoryTrauma_2" className='add-only' value="HistoryTrauma_2" />
                            Experienced;
                        </td>
                        <td className='w-187'>
                            <input type="checkbox" id="cbHistoryTrauma_3" name="cbHistoryTrauma_3" className='add-only' value="HistoryTrauma_3" />
                            Witnessed;
                        </td>
                        <td className='w-187'>
                            <input type="checkbox" id="cbHistoryTrauma_4" name="cbHistoryTrauma_4" className='add-only' value="HistoryTrauma_4" />
                            Abuse;
                        </td>
                    </tr>
                    <tr>
                        <td className='w-187'>
                            <input type="checkbox" id="cbHistoryTrauma_5" name="cbHistoryTrauma_5" className='add-only' value="HistoryTrauma_5" />
                            Neglect;
                        </td>
                        <td className='w-187'>
                            <input type="checkbox" id="cbHistoryTrauma_6" name="cbHistoryTrauma_6" className='add-only' value="HistoryTrauma_6" />
                            Violence;
                        </td>
                        <td className='w-187'>
                            <input type="checkbox" id="cbHistoryTrauma_7" name="cbHistoryTrauma_7" className='add-only' value="HistoryTrauma_7" />
                            Sexual Assault;
                        </td>
                        <td className='w-187'>&nbsp;</td>
                    </tr>
                    <tr>
                        <td className='w-187'>
                            <input type="checkbox" id="cbHistoryTrauma_8" name="cbHistoryTrauma_8" className='add-only' value="HistoryTrauma_8" />Other/Describe:
                        </td>
                        <td className='w-187'>&nbsp;</td>
                        <td className='w-187'>&nbsp;</td>
                        <td className='w-187'>&nbsp;</td>
                    </tr>
                    <tr>
                        <td className='w-187'>
                            <input type="text" id="txtHistoryTrauma_8" name="txtHistoryTrauma_8" className='add-only' />
                        </td>
                        <td className='w-187'>&nbsp;</td>
                        <td className='w-187'>&nbsp;</td>
                        <td className='w-187'>&nbsp;</td>
                    </tr>
                </table>
                <p className='w-750'>
                    Summarize trauma history:
                    <textarea id="txtSummarizeTraumaHistory" name="txtSummarizeTraumaHistory" className='add-only'></textarea>
                </p>
                <p className='w-750'>
                </p>
                <p className='w-750'>
                    <strong>XIII. LIVING SITUATION </strong>
                    <span className='small'>(Current status and functioning)</span>
                </p>
                <table>
                    <tr>
                        <td className='w-750'><span className='eleHeader'>a. Primary Residence: </span></td>
                    </tr>
                    <tr>
                        <td className='w-187'>
                            <input type="checkbox" id="cbPrimaryResidence_1" name="cbPrimaryResidence_1" className='add-only' value="PrimaryResidence_1" />
                            Parent/Guardian Home;
                        </td>
                        <td className='w-187'>
                            <input type="checkbox" id="cbPrimaryResidence_2" name="cbPrimaryResidence_2" className='add-only' value="PrimaryResidence_2" />Relative's Home;
                        </td>
                        <td className='w-187'>
                            <input type="checkbox" id="cbPrimaryResidence_3" name="cbPrimaryResidence_3" className='add-only' value="PrimaryResidence_3" />Out of Home placement;
                        </td>
                        <td className='w-187'>
                            <input type="checkbox" id="cbPrimaryResidence_4" name="cbPrimaryResidence_4" className='add-only' value="PrimaryResidence_4" />
                            Homeless;
                        </td>
                    </tr>
                    <tr>
                        <td className='w-187'>
                            <input type="checkbox" id="cbPrimaryResidence_5" name="cbPrimaryResidence_5" className='add-only' value="PrimaryResidence_5" />Other/Describe
                        </td>
                        <td className='w-187'>&nbsp;</td>
                        <td className='w-187'>&nbsp;</td>
                        <td className='w-187'>&nbsp;</td>
                    </tr>
                    <tr>
                        <td className='w-187'>
                            <input type="text" id="txtPrimaryResidence_5" name="txtPrimaryResidence_5" className='add-only' />
                        </td>
                        <td className='w-187'>&nbsp;</td>
                        <td className='w-187'>&nbsp;</td>
                        <td className='w-187'>&nbsp;</td>
                    </tr>
                </table>
                <p className='w-750'>
                    <span className='eleHeader'>How long at current residence?
                    </span>
                    <textarea id="txtAtCurrentResidence" name="txtAtCurrentResidence" className='add-only'></textarea>
                </p>
                <p className='w-750'>
                    <span className='eleHeader'>Family/Household Composition:
                    </span>
                    <textarea id="txtFamilyHouseholdComposition" name="txtFamilyHouseholdComposition" className='add-only'></textarea>
                </p>
                <p className='w-750'>
                    <span className='eleHeader'>b. Summarize current living situation:
                    </span>
                    <textarea id="txtSummarizeCurrentLivingSituation" name="txtSummarizeCurrentLivingSituation" className='add-only'></textarea>
                </p>
                <p className='w-750'>
                    <span className='eleHeader'>c. Problems with Basic Needs:</span>
                </p>
                <table>
                    <tr>
                        <td className='w-250'>
                            <input type="checkbox" id="cbProblemsBasicNeeds_2" name="cbProblemsBasicNeeds_2" className='add-only' value="Food" />Food;
                        </td>
                        <td className='w-250'>
                            <input type="checkbox" id="cbProblemsBasicNeeds_3" name="cbProblemsBasicNeeds_3" className='add-only' value="Shelter" />Shelter;
                        </td>
                        <td className='w-250'>
                            <input type="checkbox" id="cbProblemsBasicNeeds_4" name="cbProblemsBasicNeeds_4" className='add-only' value="Clothing" />Clothing;
                        </td>
                    </tr>
                    <tr>
                        <td className='w-250'>
                            <input type="checkbox" id="cbProblemsBasicNeeds_5" name="cbProblemsBasicNeeds_5" className='add-only' value="Funds" />Funds;
                        </td>
                        <td className='w-250'>
                            <input type="checkbox" id="cbProblemsBasicNeeds_6" name="cbProblemsBasicNeeds_6" className='add-only' value="Healthcare" />Healthcare;
                        </td>
                        <td className='w-250'>
                            <input type="checkbox" id="cbProblemsBasicNeeds_7" name="cbProblemsBasicNeeds_7" className='add-only' value="ADLs" />ADL's
                        </td>
                    </tr>
                    <tr>
                        <td className='w-250'>
                            <input type="checkbox" id="cbProblemsBasicNeeds_8" name="cbProblemsBasicNeeds_8" className='add-only' value="ProblemsBasicNeeds_8" />
                            Other/Describe:
                        </td>
                        <td className='w-250'>&nbsp;</td>
                        <td className='w-250'>&nbsp;</td>
                    </tr>
                    <tr>
                        <td className='w-250'>
                            <input type="text" id="txtProblemsBasicNeeds_8" name="txtProblemsBasicNeeds_8" className='add-only' />
                        </td>
                        <td className='w-250'>&nbsp;</td>
                        <td className='w-250'>&nbsp;</td>
                    </tr>
                </table>

                <p className='w-750'><strong>XIV. EDUCATIONAL/EMPLOYMENT STATUS</strong> </p>

                <p className='w-750'>
                    <span className='eleHeader'>a. Current Educational Placement/Employer:</span>
                    <textarea id="txtCurrentEducationalPlacement" name="txtCurrentEducationalPlacement" className='add-only'></textarea>
                </p>
                <p className='w-750'>
                    <span className='eleHeader'>Current or Highest Grade Completed/Degree:</span>
                    <textarea id="txtCurrentHighestGrade" name="txtCurrentHighestGrade" className='add-only'></textarea>
                </p>
                <p className='w-750'>
                    <span className='eleHeader'>Does (or did) the client attend any special classes or
                        receive any special education services:
                    </span>
                    <input type="radio" id="rbDoesClientAttendAnySpecialClass_No" name="rbDoesClientAttendAnySpecialClass" className='add-only' value="No" /> No &nbsp;

                    <input type="radio" id="rbDoesClientAttendAnySpecialClass_Yes" name="rbDoesClientAttendAnySpecialClass" className='add-only' value="Yes" /> Yes &nbsp;
                </p>
                <p className='w-750'>
                    <span className='eleHeader'>Has the client ever repeated a grade or been "held back" for any reason:
                    </span>
                    <input type="radio" id="rbHasTheClientEverRepeatedAGrade_No" name="rbHasTheClientEverRepeatedAGrade" className='add-only' value="No" /> No &nbsp;

                    <input type="radio" id="rbHasTheClientEverRepeatedAGrade_Yes" name="rbHasTheClientEverRepeatedAGrade" className='add-only' value="Yes" /> Yes &nbsp;
                </p>
                <p className='w-750'>
                    <span className='eleHeader'>Does (or did) the client have any problems in school:</span>
                    <input type="radio" id="rbDoesTheClientHaveAnyproblemsInSchool_No" name="rbDoesTheClientHaveAnyproblemsInSchool" className='add-only' value="No" /> No &nbsp;

                    <input type="radio" id="rbDoesTheClientHaveAnyproblemsInSchool_Yes" name="rbDoesTheClientHaveAnyproblemsInSchool" className='add-only' value="Yes" /> Yes &nbsp;
                </p>
                <p className='w-750'>
                    <span className='eleHeader'>Does the child have an SBLC or IEP/IAP:</span>
                    <input type="radio" id="rbDoesTheChildHaveAnSblc_No" name="rbDoesTheChildHaveAnSblc" className='add-only' value="No" /> No &nbsp;

                    <input type="radio" id="rbDoesTheChildHaveAnSblc_Yes" name="rbDoesTheChildHaveAnSblc" className='add-only' value="Yes" /> Yes &nbsp;
                </p>
                <p className='w-750'>
                    <span className='eleHeader'>Difficulties with Reading/Writing:</span>
                    <input type="radio" id="rbDifficultiesWithReadingWriting_No" name="rbDifficultiesWithReadingWriting" className='add-only' value="No" /> No &nbsp;

                    <input type="radio" id="rbDifficultiesWithReadingWriting_Yes" name="rbDifficultiesWithReadingWriting" className='add-only' value="Yes" /> Yes &nbsp;
                </p>
                <p className='w-750'>
                    <span className='eleHeader'>Estimated Literacy Level:</span>
                    <input type="text" id="txtEstimatedLiteracyLevel" name="txtEstimatedLiteracyLevel" className='add-only' />
                </p>
                <p className='w-750'>
                    <span className='eleHeader'>b. Summarize educational history and status:</span>
                    <textarea id="txtSummarizeEducationalHistoryAndStatus" name="txtSummarizeEducationalHistoryAndStatus" className='add-only'></textarea>
                </p>

                <p className='w-750'><strong>XV. SOCIAL HISTORY AND COMMUNITY INTEGRATION</strong> </p>
                <p className='w-750'>
                    <strong>a. Current status and functioning:</strong>
                    <span className='small'>(Involvement in the community, social supports and activities, social barriers)</span>
                </p>

                <p className='w-750'>
                    <span className='eleHeader'>Does Client/Member feel supported by friends or
                        family?
                    </span>
                    <input type="radio" id="rbDoesClientMemberFeelSupported_Yes" name="rbDoesClientMemberFeelSupported" className='add-only' value="Yes" /> Yes &nbsp;

                    <input type="radio" id="rbDoesClientMemberFeelSupported_No" name="rbDoesClientMemberFeelSupported" className='add-only' value="No" /> No
                </p>

                <p className='w-750'>
                    <span className='eleHeader'>Recreational Activities:</span>
                    <textarea id="txtRecreationalActivities" name="txtRecreationalActivities" className='add-only'></textarea>
                </p>

                <p className='w-750'>
                    <span className='eleHeader'>Self-Help Activities:</span>
                    <textarea id="txtSelfHelpActivities" name="txtSelfHelpActivities" className='add-only'></textarea>
                </p>
                <p className='w-750'>
                    <span className='eleHeader'>Spiritual, ethnic, cultural, age-related, and sexual
                        preferences issues pertinent to recipient's service:
                    </span>
                    <input type="text" id="txtSpiritualEthicalCultural" name="SpiritualEthicalCultural" className='add-only' />
                </p>


                <p className='w-750'>
                    <span className='eleHeader'>Supports and resources available:</span>
                    <input type="text" id="txtSupportsAndResources" name="SupportsAndResources" className='add-only' />
                </p>

                <p className='w-750'>
                    <span className='eleHeader'>Does client interact well with peers or make friends
                        easily:
                    </span>
                    <input type="radio" id="rbDoesClientInteractWell_No" name="rbDoesClientInteractWell" className='add-only' value="No" /> No &nbsp;

                    <input type="radio" id="rbDoesClientInteractWell_Yes" name="rbDoesClientInteractWell" className='add-only' value="Yes" /> Yes &nbsp;
                </p>
                <p className='w-750'>
                    <span className='eleHeader'>Does the client have difficulty interacting with
                        peers:
                    </span>
                    <input type="radio" id="rbDoesClientHaveDifficultyInteracting_No" name="rbDoesClientHaveDifficultyInteracting" className='add-only' value="No" /> No &nbsp;

                    <input type="radio" id="rbDoesClientHaveDifficultyInteracting_Yes" name="rbDoesClientHaveDifficultyInteracting" className='add-only' value="Yes" /> Yes &nbsp;
                </p>

                <p className='w-750'>
                    <span className='eleHeader'>Strengths:</span>
                    <textarea id="txtStrengths" name="strengths" className='add-only'></textarea>
                </p>
                <p className='w-750'>
                    <span className='eleHeader'>Needs:</span>
                    <textarea id="txtNeeds" name="needs" className='add-only'></textarea>
                </p>
                <p className='w-750'>
                    <span className='eleHeader'>Abilities:</span>
                    <textarea id="txtAbilities" name="abilities" className='add-only'></textarea>
                </p>
                <p className='w-750'>
                    <span className='eleHeader'>Preferences:</span>
                    <textarea id="txtPreferences" name="preferences" className='add-only'></textarea>
                </p>
                <p className='w-750'>
                    <span className='eleHeader'>b. Summarize social and community involvement:</span>
                    <textarea id="txtSummarizeSocialAndCommunity" name="SummarizeSocialAndCommunity" className='add-only'></textarea>
                </p>

                <h3>CURRENT STATUS</h3>
                <p className='w-750'>
                    <strong>XVI. MENTAL STATUS EXAMINATION</strong>
                    <span className='small'>(Circle or Check all that apply.)</span>
                </p>
                <table>
                    <tr>
                        <td className='w-750'><span className='eleHeader'>a. GENERAL APPEARANCE</span> </td>
                    </tr>
                    <tr>
                        <td className='w-250'>
                            <input type="checkbox" id="cbGeneralAppearance_1" name="cbGeneralAppearance_1" className='add-only' value="GeneralAppearance_1" />
                            Healthy;
                        </td>
                        <td className='w-250'>
                            <input type="checkbox" id="cbGeneralAppearance_2" name="cbGeneralAppearance_2" className='add-only' value="GeneralAppearance_2" />
                            As stated Age;
                        </td>
                        <td className='w-250'>
                            <input type="checkbox" id="cbGeneralAppearance_3" name="cbGeneralAppearance_3" className='add-only' value="GeneralAppearance_3" />
                            Older Than Stated Age;
                        </td>
                    </tr>
                    <tr>
                        <td className='w-250'>
                            <input type="checkbox" id="cbGeneralAppearance_4" name="cbGeneralAppearance_4" className='add-only' value="GeneralAppearance_4" />
                            Young-looking;
                        </td>
                        <td className='w-250'>
                            <input type="checkbox" id="cbGeneralAppearance_5" name="cbGeneralAppearance_5" className='add-only' value="GeneralAppearance_5" />
                            Tattoos;
                        </td>
                        <td className='w-250'>
                            <input type="checkbox" id="cbGeneralAppearance_6" name="cbGeneralAppearance_6" className='add-only' value="GeneralAppearance_6" />
                            Disheveled;
                        </td>
                    </tr>
                    <tr>
                        <td className='w-250'>
                            <input type="checkbox" id="cbGeneralAppearance_7" name="cbGeneralAppearance_7" className='add-only' value="GeneralAppearance_7" />
                            Unkempt;
                        </td>
                        <td className='w-250'>
                            <input type="checkbox" id="cbGeneralAppearance_8" name="cbGeneralAppearance_8" className='add-only' value="GeneralAppearance_8" />
                            Malodorous;
                        </td>
                        <td className='w-250'>
                            <input type="checkbox" id="cbGeneralAppearance_9" name="cbGeneralAppearance_9" className='add-only' value="GeneralAppearance_9" />
                            Thin;
                        </td>
                    </tr>
                    <tr>
                        <td className='w-250'>
                            <input type="checkbox" id="cbGeneralAppearance_10" name="cbGeneralAppearance_10" className='add-only' value="GeneralAppearance_10" />
                            Overweight;
                        </td>
                        <td className='w-250'>
                            <input type="checkbox" id="cbGeneralAppearance_11" name="cbGeneralAppearance_11" className='add-only' value="GeneralAppearance_11" />
                            Obese;
                        </td>
                        <td className='w-250'>&nbsp;</td>
                    </tr>
                    <tr>
                        <td className='w-250'>
                            <input type="checkbox" id="cbGeneralAppearance_12" name="cbGeneralAppearance_12" className='add-only' value="GeneralAppearance_12" />Other/Describe:
                        </td>
                        <td className='w-250'>&nbsp;</td>
                        <td className='w-250'>&nbsp;</td>
                    </tr>
                    <tr>
                        <td className='w-250'>
                            <input type="text" id="txtGeneralAppearance_12" name="txtGeneralAppearance_12" className='add-only' />
                        </td>
                        <td className='w-250'>&nbsp;</td>
                        <td className='w-250'>&nbsp;</td>
                    </tr>
                </table>
                <table>
                    <tr>
                        <td className='w-750'><span className='eleHeader'>b. BEHAVIOR & PSYCHOMOTOR ACTIVITY</span> </td>
                    </tr>
                    <tr>
                        <td className='w-250'>
                            <input type="checkbox" id="cbPsychomotorActivity_1" name="cbPsychomotorActivity_1" className='add-only' value="PsychomotorActivity_1" />
                            Normal;
                        </td>
                        <td className='w-250'>
                            <input type="checkbox" id="cbPsychomotorActivity_2" name="cbPsychomotorActivity_2" className='add-only' value="PsychomotorActivity_2" />
                            Overactive;
                        </td>
                        <td className='w-250'>
                            <input type="checkbox" id="cbPsychomotorActivity_3" name="cbPsychomotorActivity_3" className='add-only' value="PsychomotorActivity_3" />
                            Hypoactive;
                        </td>
                    </tr>
                    <tr>
                        <td className='w-250'>
                            <input type="checkbox" id="cbPsychomotorActivity_4" name="cbPsychomotorActivity_4" className='add-only' value="PsychomotorActivity_4" />
                            Catatonia;
                        </td>
                        <td className='w-250'>
                            <input type="checkbox" id="cbPsychomotorActivity_5" name="cbPsychomotorActivity_5" className='add-only' value="PsychomotorActivity_5" />
                            Tremor;
                        </td>
                        <td className='w-250'>
                            <input type="checkbox" id="cbPsychomotorActivity_6" name="cbPsychomotorActivity_6" className='add-only' value="PsychomotorActivity_6" />
                            Tics;
                        </td>
                    </tr>
                    <tr>
                        <td className='w-250'>
                            <input type="checkbox" id="cbPsychomotorActivity_7" name="cbPsychomotorActivity_7" className='add-only' value="PsychomotorActivity_7" />
                            Combative;
                        </td>
                        <td className='w-250'>&nbsp;</td>
                        <td className='w-250'>&nbsp;</td>
                    </tr>
                    <tr>
                        <td className='w-250'>
                            <input type="checkbox" id="cbPsychomotorActivity_9" name="cbPsychomotorActivity_9" className='add-only' value="PsychomotorActivity_9" />Other/Describe:
                        </td>
                        <td className='w-250'>&nbsp;</td>
                        <td className='w-250'>&nbsp;</td>
                    </tr>
                    <tr>
                        <td className='w-250'>
                            <input type="text" id="txtPsychomotorActivity_9" name="txtPsychomotorActivity_9" className='add-only' />
                        </td>
                        <td className='w-250'>&nbsp;</td>
                        <td className='w-250'>&nbsp;</td>
                    </tr>
                </table>
                <table>
                    <tr>
                        <td className='w-750'><span className='eleHeader'>c. ATTITUDE</span> </td>
                    </tr>
                    <tr>
                        <td className='w-250'>
                            <input type="checkbox" id="cbAtitude_1" name="cbAtitude_1" className='add-only' value="Atitude_1" />
                            Optimal;
                        </td>
                        <td className='w-250'>
                            <input type="checkbox" id="cbAtitude_2" name="cbAtitude_2" className='add-only' value="Atitude_2" />
                            Constructive;
                        </td>
                        <td className='w-250'>
                            <input type="checkbox" id="cbAtitude_3" name="cbAtitude_3" className='add-only' value="Atitude_3" />
                            Motivated;
                        </td>
                    </tr>
                    <tr>
                        <td className='w-250'>
                            <input type="checkbox" id="cbAtitude_4" name="cbAtitude_4" className='add-only' value="Atitude_4" />
                            Obstructive;
                        </td>
                        <td className='w-250'>
                            <input type="checkbox" id="cbAtitude_5" name="cbAtitude_5" className='add-only' value="Atitude_5" />
                            Adversarial;
                        </td>
                        <td className='w-250'>
                            <input type="checkbox" id="cbAtitude_6" name="cbAtitude_6" className='add-only' value="Atitude_6" />
                            Inaccessible;
                        </td>
                    </tr>
                    <tr>
                        <td className='w-250'>
                            <input type="checkbox" id="cbAtitude_7" name="cbAtitude_7" className='add-only' value="Atitude_7" />
                            Cooperative;
                        </td>
                        <td className='w-250'>
                            <input type="checkbox" id="cbAtitude_8" name="cbAtitude_8" className='add-only' value="Atitude_8" />
                            Seductive;
                        </td>
                        <td className='w-250'>
                            <input type="checkbox" id="cbAtitude_9" name="cbAtitude_9" className='add-only' value="Atitude_9" />
                            Defensive;
                        </td>
                    </tr>
                    <tr>
                        <td className='w-250'>
                            <input type="checkbox" id="cbAtitude_10" name="cbAtitude_10" className='add-only' value="Atitude_10" />
                            Hostile;
                        </td>
                        <td className='w-250'>
                            <input type="checkbox" id="cbAtitude_11" name="cbAtitude_11" className='add-only' value="Atitude_11" />
                            Guarded;
                        </td>
                        <td className='w-250'>
                            <input type="checkbox" id="cbAtitude_12" name="cbAtitude_12" className='add-only' value="Atitude_12" />
                            Apathetic;
                        </td>
                    </tr>
                    <tr>
                        <td className='w-250'>
                            <input type="checkbox" id="cbAtitude_13" name="cbAtitude_13" className='add-only' value="Atitude_13" />
                            Evasive;
                        </td>
                        <td className='w-250'>&nbsp;</td>
                        <td className='w-250'>&nbsp;</td>
                    </tr>
                    <tr>
                        <td className='w-250'>
                            <input type="checkbox" id="cbAtitude_14" name="cbAtitude_14" className='add-only' value="Atitude_14" />Other/Explain:
                        </td>
                        <td className='w-250'>&nbsp;</td>
                        <td className='w-250'>&nbsp;</td>
                    </tr>
                    <tr>
                        <td className='w-250'>
                            <input type="text" id="txtAtitude_14" name="txtAtitude_14" className='add-only' />
                        </td>
                        <td className='w-250'>&nbsp;</td>
                        <td className='w-250'>&nbsp;</td>
                    </tr>
                </table>
                <table>
                    <tr>
                        <td className='w-750'><span className='eleHeader'>d. SPEECH</span> </td>
                    </tr>
                    <tr>
                        <td className='w-250'>
                            <input type="checkbox" id="cbSpeech_1" name="cbSpeech_1" className='add-only' value="Speech_1" />
                            Normal;
                        </td>
                        <td className='w-250'>
                            <input type="checkbox" id="cbSpeech_2" name="cbSpeech_2" className='add-only' value="Speech_2" />
                            Spontaneous;
                        </td>
                        <td className='w-250'>
                            <input type="checkbox" id="cbSpeech_3" name="cbSpeech_3" className='add-only' value="Speech_3" />
                            Slow;
                        </td>
                    </tr>
                    <tr>
                        <td className='w-250'>
                            <input type="checkbox" id="cbSpeech_4" name="cbSpeech_4" className='add-only' value="Speech_4" />
                            Impoverished;
                        </td>
                        <td className='w-250'>
                            <input type="checkbox" id="cbSpeech_5" name="cbSpeech_5" className='add-only' value="Speech_5" />
                            Hesitant;
                        </td>
                        <td className='w-250'>
                            <input type="checkbox" id="cbSpeech_6" name="cbSpeech_6" className='add-only' value="Speech_6" />
                            Monotonous;
                        </td>
                    </tr>
                    <tr>
                        <td className='w-250'>
                            <input type="checkbox" id="cbSpeech_7" name="cbSpeech_7" className='add-only' value="Speech_7" />
                            Soft/Whispered;
                        </td>
                        <td className='w-250'>
                            <input type="checkbox" id="cbSpeech_8" name="cbSpeech_8" className='add-only' value="Speech_8" />
                            Mumbled;
                        </td>
                        <td className='w-250'>
                            <input type="checkbox" id="cbSpeech_9" name="cbSpeech_9" className='add-only' value="Speech_9" />
                            Rapid;
                        </td>
                    </tr>
                    <tr>
                        <td className='w-250'>
                            <input type="checkbox" id="cbSpeech_10" name="cbSpeech_10" className='add-only' value="Speech_10" />
                            Pressured;
                        </td>
                        <td className='w-250'>
                            <input type="checkbox" id="cbSpeech_11" name="cbSpeech_11" className='add-only' value="Speech_11" />
                            Verbose;
                        </td>
                        <td className='w-250'>
                            <input type="checkbox" id="cbSpeech_12" name="cbSpeech_12" className='add-only' value="Speech_12" />
                            Loud;
                        </td>
                    </tr>
                    <tr>
                        <td className='w-250'>
                            <input type="checkbox" id="cbSpeech_13" name="cbSpeech_13" className='add-only' value="Speech_13" />
                            Slurred;
                        </td>
                        <td className='w-250'>
                            <input type="checkbox" id="cbSpeech_14" name="cbSpeech_14" className='add-only' value="Speech_14" />
                            Impediment;
                        </td>
                        <td className='w-250'>&nbsp;</td>
                    </tr>
                    <tr>
                        <td className='w-250'>
                            <input type="checkbox" id="cbSpeech_15" name="cbSpeech_15" className='add-only' value="Speech_15" />Other/Describe:
                        </td>
                        <td className='w-250'>&nbsp;</td>
                        <td className='w-250'>&nbsp;</td>
                    </tr>
                    <tr>
                        <td className='w-250'>
                            <input type="text" id="txtSpeech_15" name="txtSpeech_15" className='add-only' />
                        </td>
                        <td className='w-250'>&nbsp;</td>
                        <td className='w-250'>&nbsp;</td>
                    </tr>
                </table>
                <table>
                    <tr>
                        <td className='w-750'><span className='eleHeader'>e. MOOD</span> </td>
                    </tr>
                    <tr>
                        <td className='w-250'>
                            <input type="checkbox" id="cbMood_1" name="cbMood_1" className='add-only' value="Mood_1" />
                            Dysphoric;
                        </td>
                        <td className='w-250'>
                            <input type="checkbox" id="cbMood_2" name="cbMood_2" className='add-only' value="Mood_2" />
                            Euthymic ;
                        </td>
                        <td className='w-250'>
                            <input type="checkbox" id="cbMood_3" name="cbMood_3" className='add-only' value="Mood_3" />
                            Expansive;
                        </td>
                    </tr>
                    <tr>
                        <td className='w-250'>
                            <input type="checkbox" id="cbMood_4" name="cbMood_4" className='add-only' value="Mood_4" />
                            Irritable;
                        </td>
                        <td className='w-250'>
                            <input type="checkbox" id="cbMood_5" name="cbMood_5" className='add-only' value="Mood_5" />
                            Labile;
                        </td>
                        <td className='w-250'>
                            <input type="checkbox" id="cbMood_6" name="cbMood_6" className='add-only' value="Mood_6" />
                            Elevated;
                        </td>
                    </tr>
                    <tr>
                        <td className='w-250'>
                            <input type="checkbox" id="cbMood_7" name="cbMood_7" className='add-only' value="Mood_7" />
                            Euphoric;
                        </td>
                        <td className='w-250'>
                            <input type="checkbox" id="cbMood_8" name="cbMood_8" className='add-only' value="Mood_8" />
                            Ecstatic;
                        </td>
                        <td className='w-250'>
                            <input type="checkbox" id="cbMood_9" name="cbMood_9" className='add-only' value="Mood_9" />
                            Depressed;
                        </td>
                    </tr>
                    <tr>
                        <td className='w-250'>
                            <input type="checkbox" id="cbMood_10" name="cbMood_10" className='add-only' value="Mood_10" />
                            Grief/mourning;
                        </td>
                        <td className='w-250'>
                            <input type="checkbox" id="cbMood_11" name="cbMood_11" className='add-only' value="Mood_11" />
                            Alexithymic;
                        </td>
                        <td className='w-250'>
                            <input type="checkbox" id="cbMood_12" name="cbMood_12" className='add-only' value="Mood_12" />
                            Elated;
                        </td>
                    </tr>
                    <tr>
                        <td className='w-250'>
                            <input type="checkbox" id="cbMood_13" name="cbMood_13" className='add-only' value="Mood_13" />
                            Hypomanic;
                        </td>
                        <td className='w-250'>
                            <input type="checkbox" id="cbMood_14" name="cbMood_14" className='add-only' value="Mood_14" />
                            Manic;
                        </td>
                        <td className='w-250'>
                            <input type="checkbox" id="cbMood_15" name="cbMood_15" className='add-only' value="Mood_15" />
                            Anxious;
                        </td>
                    </tr>
                    <tr>
                        <td className='w-250'>
                            <input type="checkbox" id="cbMood_16" name="cbMood_16" className='add-only' value="Mood_16" />
                            Tense;
                        </td>
                        <td className='w-250'>&nbsp;</td>
                        <td className='w-250'>&nbsp;</td>
                    </tr>
                    <tr>
                        <td className='w-250'>
                            <input type="checkbox" id="cbMood_17" name="cbMood_17" className='add-only' value="Mood_17" />Other/Describe:
                        </td>
                        <td className='w-250'>&nbsp;</td>
                        <td className='w-250'>&nbsp;</td>
                    </tr>
                    <tr>
                        <td className='w-250'>
                            <input type="text" id="txtMood_17" name="txtMood_17" className='add-only' />
                        </td>
                        <td className='w-250'>&nbsp;</td>
                        <td className='w-250'>&nbsp;</td>
                    </tr>
                </table>
                <table>
                    <tr>
                        <td className='w-750'><span className='eleHeader'>f. AFFECT</span> </td>
                    </tr>
                    <tr>
                        <td className='w-250'>
                            <input type="checkbox" id="cbAffect_1" name="cbAffect_1" className='add-only' value="Affect_1" />
                            Appropriate;
                        </td>
                        <td className='w-250'>
                            <input type="checkbox" id="cbAffect_2" name="cbAffect_2" className='add-only' value="Affect_2" />
                            Inappropriate;
                        </td>
                        <td className='w-250'>
                            <input type="checkbox" id="cbAffect_3" name="cbAffect_3" className='add-only' value="Affect_3" />
                            Blunted;
                        </td>
                    </tr>
                    <tr>
                        <td className='w-250'>
                            <input type="checkbox" id="cbAffect_4" name="cbAffect_4" className='add-only' value="Affect_4" />
                            Restricted;
                        </td>
                        <td className='w-250'>
                            <input type="checkbox" id="cbAffect_5" name="cbAffect_5" className='add-only' value="Affect_5" />
                            Flat;
                        </td>
                        <td className='w-250'>
                            <input type="checkbox" id="cbAffect_6" name="cbAffect_6" className='add-only' value="Affect_6" />
                            Labile;
                        </td>
                    </tr>
                    <tr>
                        <td className='w-250'>
                            <input type="checkbox" id="cbAffect_7" name="cbAffect_7" className='add-only' value="Affect_7" />
                            Tearful;
                        </td>
                        <td className='w-250'>
                            <input type="checkbox" id="cbAffect_8" name="cbAffect_8" className='add-only' value="Affect_8" />
                            Intense;
                        </td>
                        <td className='w-250'>&nbsp;</td>
                    </tr>
                    <tr>
                        <td className='w-250'>
                            <input type="checkbox" id="cbAffect_9" name="cbAffect_9" className='add-only' value="Affect_9" />Other/Describe:
                        </td>
                        <td className='w-250'>&nbsp;</td>
                        <td className='w-250'>&nbsp;</td>
                    </tr>
                    <tr>
                        <td className='w-250'>
                            <input type="text" id="txtAffect_9" name="txtAffect_9" className='add-only' />
                        </td>
                        <td className='w-250'>&nbsp;</td>
                        <td className='w-250'>&nbsp;</td>
                    </tr>
                </table>
                <table>
                    <tr>
                        <td className='w-750'><span className='eleHeader'>g. PERCEPTUAL DISTURBANCES</span> </td>
                    </tr>
                    <tr>
                        <td className='w-250'>
                            <input type="checkbox" id="cbPerceptualDisturbances_1" name="cbPerceptualDisturbances_1" className='add-only' value="PerceptualDisturbances_1" />
                            None;
                        </td>
                        <td className='w-250'>&nbsp;</td>
                        <td className='w-250'>&nbsp;</td>
                    </tr>
                    <tr>
                        <td className='w-750'>
                            <strong>Hallucinations</strong>
                        </td>
                    </tr>
                    <tr>
                        <td className='w-250'>
                            <input type="checkbox" id="cbPerceptualDisturbances_3" name="cbPerceptualDisturbances_3" className='add-only' value="PerceptualDisturbances_3" />
                            Auditory;
                        </td>
                        <td className='w-250'>
                            <input type="checkbox" id="cbPerceptualDisturbances_4" name="cbPerceptualDisturbances_4" className='add-only' value="PerceptualDisturbances_4" />
                            Visual;
                        </td>
                        <td className='w-250'>
                            <input type="checkbox" id="cbPerceptualDisturbances_5" name="cbPerceptualDisturbances_5" className='add-only' value="PerceptualDisturbances_5" />
                            Olfactory;
                        </td>
                    </tr>
                    <tr>
                        <td className='w-250'>
                            <input type="checkbox" id="cbPerceptualDisturbances_6" name="cbPerceptualDisturbances_6" className='add-only' value="PerceptualDisturbances_6" />
                            Tactile;
                        </td>
                        <td className='w-250'>&nbsp;</td>
                        <td className='w-250'>&nbsp;</td>
                    </tr>
                    <tr>
                        <td className='w-250'>
                            <input type="checkbox" id="cbPerceptualDisturbances_7" name="cbPerceptualDisturbances_7" className='add-only' value="PerceptualDisturbances_7" />Other/Describe:
                        </td>
                        <td className='w-250'>&nbsp;</td>
                        <td className='w-250'>&nbsp;</td>
                    </tr>
                    <tr>
                        <td className='w-250'>
                            <input type="text" id="txtPerceptualDisturbances_7" name="txtPerceptualDisturbances_7" className='add-only' />
                        </td>
                        <td className='w-250'>&nbsp;</td>
                        <td className='w-250'>&nbsp;</td>
                    </tr>
                </table>
                <table>
                    <tr>
                        <td className='w-750'><span className='eleHeader'>h. THOUGHT PROCESS</span> </td>
                    </tr>
                    <tr>
                        <td className='w-250'>
                            <input type="checkbox" id="cbThoughtProcess_1" name="cbThoughtProcess_1" className='add-only' value="ThoughtProcess_1" />
                            Logical/Coherent;
                        </td>
                        <td className='w-250'>
                            <input type="checkbox" id="cbThoughtProcess_2" name="cbThoughtProcess_2" className='add-only' value="ThoughtProcess_2" />
                            Incomprehensible;
                        </td>
                        <td className='w-250'>
                            <input type="checkbox" id="cbThoughtProcess_3" name="cbThoughtProcess_3" className='add-only' value="ThoughtProcess_3" />
                            Incoherent;
                        </td>
                    </tr>
                    <tr>
                        <td className='w-250'>
                            <input type="checkbox" id="cbThoughtProcess_4" name="cbThoughtProcess_4" className='add-only' value="ThoughtProcess_4" />
                            Flight of Ideas;
                        </td>
                        <td className='w-250'>
                            <input type="checkbox" id="cbThoughtProcess_5" name="cbThoughtProcess_5" className='add-only' value="ThoughtProcess_5" />
                            Loose Associations;
                        </td>
                        <td className='w-250'>
                            <input type="checkbox" id="cbThoughtProcess_6" name="cbThoughtProcess_6" className='add-only' value="ThoughtProcess_6" />
                            Tangential;
                        </td>
                    </tr>
                    <tr>
                        <td className='w-250'>
                            <input type="checkbox" id="cbThoughtProcess_7" name="cbThoughtProcess_7" className='add-only' value="ThoughtProcess_7" />
                            Circumstantial;
                        </td>
                        <td className='w-250'>
                            <input type="checkbox" id="cbThoughtProcess_8" name="cbThoughtProcess_8" className='add-only' value="ThoughtProcess_8" />
                            Rambling;
                        </td>
                        <td className='w-250'>
                            <input type="checkbox" id="cbThoughtProcess_9" name="cbThoughtProcess_9" className='add-only' value="ThoughtProcess_9" />
                            Evasive;
                        </td>
                    </tr>
                    <tr>
                        <td className='w-250'>
                            <input type="checkbox" id="cbThoughtProcess_10" name="cbThoughtProcess_10" className='add-only' value="ThoughtProcess_10" />
                            Racing Thoughts;
                        </td>
                        <td className='w-250'>
                            <input type="checkbox" id="cbThoughtProcess_11" name="cbThoughtProcess_11" className='add-only' value="ThoughtProcess_11" />
                            Perseveration;
                        </td>
                        <td className='w-250'>
                            <input type="checkbox" id="cbThoughtProcess_12" name="cbThoughtProcess_12" className='add-only' value="ThoughtProcess_12" />
                            Thought Blocking;
                        </td>
                    </tr>
                    <tr>
                        <td className='w-250'>
                            <input type="checkbox" id="cbThoughtProcess_13" name="cbThoughtProcess_13" className='add-only' value="ThoughtProcess_13" />
                            Concrete;
                        </td>
                        <td className='w-250'>&nbsp;</td>
                        <td className='w-250'>&nbsp;</td>
                    </tr>
                    <tr>
                        <td className='w-250'>
                            <input type="checkbox" id="cbThoughtProcess_14" name="cbThoughtProcess_14" className='add-only' value="ThoughtProcess_14" />Other/Describe:
                        </td>
                        <td className='w-250'>&nbsp;</td>
                        <td className='w-250'>&nbsp;</td>
                    </tr>
                    <tr>
                        <td className='w-250'>
                            <input type="text" id="txtThoughtProcess_14" name="txtThoughtProcess_14" className='add-only' />
                        </td>
                        <td className='w-250'>&nbsp;</td>
                        <td className='w-250'>&nbsp;</td>
                    </tr>
                </table>
                <table>
                    <tr>
                        <td className='w-750'><span className='eleHeader'>i. THOUGHT CONTENT</span> </td>
                    </tr>
                    <tr>
                        <td className='w-250'>
                            <input type="checkbox" id="cbThoughtContent_2" name="cbThoughtContent_2" className='add-only' value="ThoughtContent_2" />
                            Preoccupations;
                        </td>
                        <td className='w-250'>
                            <input type="checkbox" id="cbThoughtContent_3" name="cbThoughtContent_3" className='add-only' value="ThoughtContent_3" />
                            Obsessions;
                        </td>
                        <td className='w-250'>
                            <input type="checkbox" id="cbThoughtContent_4" name="cbThoughtContent_4" className='add-only' value="ThoughtContent_4" />
                            Compulsions;
                        </td>
                    </tr>
                    <tr>
                        <td className='w-250'>
                            <input type="checkbox" id="cbThoughtContent_5" name="cbThoughtContent_5" className='add-only' value="ThoughtContent_5" />
                            Phobias;
                        </td>
                        <td className='w-250'>
                            <input type="checkbox" id="cbThoughtContent_6" name="cbThoughtContent_6" className='add-only' value="ThoughtContent_6" />
                            Delusions;
                        </td>
                        <td className='w-250'>
                            <input type="checkbox" id="cbThoughtContent_7" name="cbThoughtContent_7" className='add-only' value="ThoughtContent_7" />
                            Thought Broadcasting;
                        </td>
                    </tr>
                    <tr>
                        <td className='w-250'>
                            <input type="checkbox" id="cbThoughtContent_8" name="cbThoughtContent_8" className='add-only' value="ThoughtContent_8" />
                            Thought Insertion;
                        </td>
                        <td className='w-250'>
                            <input type="checkbox" id="cbThoughtContent_9" name="cbThoughtContent_9" className='add-only' value="ThoughtContent_9" />
                            Thought Withdrawal;
                        </td>
                        <td className='w-250'>
                            <input type="checkbox" id="cbThoughtContent_10" name="cbThoughtContent_10" className='add-only' value="ThoughtContent_10" />
                            Ideas of Reference;
                        </td>
                    </tr>
                    <tr>
                        <td className='w-250'>
                            <input type="checkbox" id="cbThoughtContent_11" name="cbThoughtContent_11" className='add-only' value="ThoughtContent_11" />
                            Ideas of Influence;
                        </td>
                        <td className='w-250'>
                            <input type="checkbox" id="cbThoughtContent_12" name="cbThoughtContent_12" className='add-only' value="ThoughtContent_12" />
                            Delusions;
                        </td>
                        <td className='w-250'>&nbsp;</td>
                    </tr>
                    <tr>
                        <td className='w-250'>
                            <input type="checkbox" id="cbThoughtContent_13" name="cbThoughtContent_13" className='add-only' value="ThoughtContent_13" />Other/Describe:
                        </td>
                        <td className='w-250'>&nbsp;</td>
                        <td className='w-250'>&nbsp;</td>
                    </tr>
                    <tr>
                        <td className='w-250'>
                            <input type="text" id="txtThoughtContent_13" name="txtThoughtContent_13" className='add-only' />
                        </td>
                        <td className='w-250'>&nbsp;</td>
                        <td className='w-250'>&nbsp;</td>
                    </tr>
                </table>
                <table>
                    <tr>
                        <td className='w-750'><span className='eleHeader'>j. SUICIDAL/HOMICIDAL IDEATION</span> </td>
                    </tr>
                    <tr>
                        <td className='w-250'>
                            <input type="checkbox" id="cbSuicidalHomicidalIdeation_1" name="cbSuicidalHomicidalIdeation_1" className='add-only' value="SuicidalHomicidalIdeation_1" />
                            Suicidal Thoughts;
                        </td>
                        <td className='w-250'>
                            <input type="checkbox" id="cbSuicidalHomicidalIdeation_2" name="cbSuicidalHomicidalIdeation_2" className='add-only' value="SuicidalHomicidalIdeation_2" />
                            Suicidal Attempts;
                        </td>
                        <td className='w-250'>
                            <input type="checkbox" id="cbSuicidalHomicidalIdeation_3" name="cbSuicidalHomicidalIdeation_3" className='add-only' value="SuicidalHomicidalIdeation_3" />
                            Suicidal Intent
                        </td>
                    </tr>
                    <tr>
                        <td className='w-250'>
                            <input type="checkbox" id="cbSuicidalHomicidalIdeation_4" name="cbSuicidalHomicidalIdeation_4" className='add-only' value="SuicidalHomicidalIdeation_4" />
                            Suicidal Plans;
                        </td>
                        <td className='w-250'>
                            <input type="checkbox" id="cbSuicidalHomicidalIdeation_5" name="cbSuicidalHomicidalIdeation_5" className='add-only' value="SuicidalHomicidalIdeation_5" />
                            History of Self-Injurious Behavior;
                        </td>
                        <td className='w-250'>
                            <input type="checkbox" id="cbSuicidalHomicidalIdeation_6" name="cbSuicidalHomicidalIdeation_6" className='add-only' value="SuicidalHomicidalIdeation_6" />
                            Homicidal Thoughts;
                        </td>
                    </tr>
                    <tr>
                        <td className='w-250'>
                            <input type="checkbox" id="cbSuicidalHomicidalIdeation_7" name="cbSuicidalHomicidalIdeation_7" className='add-only' value="SuicidalHomicidalIdeation_7" />
                            Homicidal Attempts;
                        </td>
                        <td className='w-250'>
                            <input type="checkbox" id="cbSuicidalHomicidalIdeation_8" name="cbSuicidalHomicidalIdeation_8" className='add-only' value="SuicidalHomicidalIdeation_8" />
                            Homicidal Intent;
                        </td>
                        <td className='w-250'>
                            <input type="checkbox" id="cbSuicidalHomicidalIdeation_9" name="cbSuicidalHomicidalIdeation_9" className='add-only' value="SuicidalHomicidalIdeation_9" />
                            Homicidal Plans;
                        </td>
                    </tr>
                    <tr>
                        <td className='w-750'>
                            <input type="checkbox" id="cbSuicidalHomicidalIdeation_10" name="cbSuicidalHomicidalIdeation_10" className='add-only' value="SuicidalHomicidalIdeation_10" />Other/Describe:
                        </td>
                    </tr>
                    <tr>
                        <td className='w-250'>
                            <input type="text" id="txtSuicidalHomicidalIdeation_4" name="txtSuicidalHomicidalIdeation_4" className='add-only' />
                        </td>
                        <td className='w-250'>&nbsp;</td>
                        <td className='w-250'>&nbsp;</td>
                    </tr>
                </table>
                <table>
                    <tr>
                        <td className='w-750'><span className='eleHeader'>k. SENSORIUM/COGNITION</span> </td>
                    </tr>
                    <tr>
                        <td className='w-250'>
                            <input type="checkbox" id="cbSensoriumCognition_1" name="cbSensoriumCognition_1" className='add-only' value="SensoriumCognition_1" />
                            Alert;
                        </td>
                        <td className='w-250'>
                            <input type="checkbox" id="cbSensoriumCognition_2" name="cbSensoriumCognition_2" className='add-only' value="SensoriumCognition_2" />
                            Lethargic;
                        </td>
                        <td className='w-250'>
                            <input type="checkbox" id="cbSensoriumCognition_3" name="cbSensoriumCognition_3" className='add-only' value="SensoriumCognition_3" />
                            Somnolent;
                        </td>
                    </tr>
                    <tr>
                        <td className='w-250'>
                            <input type="checkbox" id="cbSensoriumCognition_4" name="cbSensoriumCognition_4" className='add-only' value="SensoriumCognition_4" />
                            Stuporous;
                        </td>
                        <td className='w-250'>
                            <input type="checkbox" id="cbSensoriumCognition_5" name="cbSensoriumCognition_5" className='add-only' value="SensoriumCognition_5" />
                            Normal Concentration;
                        </td>
                        <td className='w-250'>
                            <input type="checkbox" id="cbSensoriumCognition_6" name="cbSensoriumCognition_6" className='add-only' value="SensoriumCognition_6" />
                            Impaired Concentration;
                        </td>
                    </tr>
                    <tr>
                        <td className='w-250'>
                            <input type="checkbox" id="cbSensoriumCognition_7" name="cbSensoriumCognition_7" className='add-only' value="SensoriumCognition_7" />Other/Describe:
                        </td>
                        <td className='w-250'>&nbsp;</td>
                        <td className='w-250'>&nbsp;</td>
                    </tr>
                    <tr>
                        <td className='w-250'>
                            <input type="text" id="txtSensoriumCognition_7" name="txtSensoriumCognition_7" className='add-only' />
                        </td>
                        <td className='w-250'>&nbsp;</td>
                        <td className='w-250'>&nbsp;</td>
                    </tr>
                    <tr>
                        <td className='w-750'><strong>Oriented to:</strong></td>
                    </tr>
                    <tr>
                        <td className='w-250'>
                            <input type="checkbox" id="cbOrientation_1" name="cbOrientation_1" className='add-only' value="Orientation_1" />
                            Person;
                        </td>
                        <td className='w-250'>
                            <input type="checkbox" id="cbOrientation_2" name="cbOrientation_2" className='add-only' value="Orientation_2" />
                            Place;
                        </td>
                        <td className='w-250'>
                            <input type="checkbox" id="cbOrientation_3" name="cbOrientation_3" className='add-only' value="Orientation_3" />
                            Time;
                        </td>
                    </tr>
                    <tr>
                        <td className='w-250'>
                            <input type="checkbox" id="cbOrientation_4" name="cbOrientation_4" className='add-only' value="Orientation_4" />
                            Situation;
                        </td>
                        <td className='w-250'>&nbsp;</td>
                        <td className='w-250'>&nbsp;</td>
                    </tr>
                </table>
                <table>
                    <tr>
                        <td className='w-750'><span className='eleHeader'>l. MEMORY</span> </td>
                    </tr>
                    <tr>
                        <td className='w-250'><strong>Remote Memory:</strong></td>
                        <td className='w-250'>
                            <input type="checkbox" id="cbRemoteMemory_1" name="cbRemoteMemory_1" className='add-only' value="RemoteMemory_1" />
                            Normal;
                        </td>
                        <td className='w-250'>
                            <input type="checkbox" id="cbRemoteMemory_2" name="cbRemoteMemory_2" className='add-only' value="RemoteMemory_2" />
                            Impaired;
                        </td>
                    </tr>
                    <tr>
                        <td className='w-250'><strong>Recent Memory:</strong></td>
                        <td className='w-250'>
                            <input type="checkbox" id="cbRecentMemory_1" name="cbRecentMemory_1" className='add-only' value="RecentMemory_1" />
                            Normal;
                        </td>
                        <td className='w-250'>
                            <input type="checkbox" id="cbRecentMemory_2" name="cbRecentMemory_2" className='add-only' value="RecentMemory_2" />
                            Impaired;
                        </td>
                    </tr>
                    <tr>
                        <td className='w-250'><strong>Immediate Recall:</strong> </td>
                        <td className='w-250'>
                            <input type="checkbox" id="cbImmediateMemory_1" name="cbImmediateMemory_1" className='add-only' value="ImmediateMemory_1" />
                            Normal;
                        </td>
                        <td className='w-250'>
                            <input type="checkbox" id="cbImmediateMemory_2" name="cbImmediateMemory_2" className='add-only' value="ImmediateMemory_2" />
                            Impaired;
                        </td>
                    </tr>
                    <tr>
                        <td className='w-250'>
                            <input type="checkbox" id="cbMemoryOtherDescribe" name="cbMemoryOtherDescribe" className='add-only' value="MemoryOtherDescribe" />Other/Describe:
                        </td>
                        <td className='w-250'>&nbsp;</td>
                        <td className='w-250'>&nbsp;</td>
                    </tr>
                    <tr>
                        <td className='w-250'>
                            <input type="text" id="txtMemoryOtherDescribe" name="txtMemoryOtherDescribe" className='add-only' />
                        </td>
                        <td className='w-250'>&nbsp;</td>
                        <td className='w-250'>&nbsp;</td>
                    </tr>
                </table>
                <table>
                    <tr>
                        <td className='w-750'><span className='eleHeader'>m. INTELLECTUAL FUNCTIONING (Estimate)</span> </td>
                    </tr>
                    <tr>
                        <td className='w-250'>
                            <input type="checkbox" id="cbIntellectualFunctioning_1" name="cbIntellectualFunctioning_1" className='add-only' value="IntellectualFunctioning_1" />
                            Above Avg.;
                        </td>
                        <td className='w-250'>
                            <input type="checkbox" id="cbIntellectualFunctioning_2" name="cbIntellectualFunctioning_2" className='add-only' value="IntellectualFunctioning_2" />
                            Normal/Avg.;
                        </td>
                        <td className='w-250'>
                            <input type="checkbox" id="cbIntellectualFunctioning_3" name="cbIntellectualFunctioning_3" className='add-only' value="IntellectualFunctioning_3" />
                            Borderline;
                        </td>
                    </tr>

                    <tr>
                        <td className='w-750'><strong>Mental Retardation:</strong> </td>
                    </tr>
                    <tr>
                        <td className='w-250'>
                            <input type="checkbox" id="cbIntellectualDiability_1" name="cbIntellectualDiability_1" className='add-only' value="IntellectualDiability_1" />
                            Mild;
                        </td>
                        <td className='w-250'>
                            <input type="checkbox" id="cbIntellectualDiability_2" name="cbIntellectualDiability_2" className='add-only' value="IntellectualDiability_2" />
                            Moderate;
                        </td>
                        <td className='w-250'>
                            <input type="checkbox" id="cbIntellectualDiability_3" name="cbIntellectualDiability_3" className='add-only' value="IntellectualDiability_3" />
                            Severe;
                        </td>
                    </tr>
                    <tr>
                        <td className='w-250'>
                            <input type="checkbox" id="cbIntellectualDiability_4" name="cbIntellectualDiability_4" className='add-only' value="IntellectualDiability_4" />Other/Describe:
                        </td>
                        <td className='w-250'>&nbsp;</td>
                        <td className='w-250'>&nbsp;</td>
                    </tr>
                    <tr>
                        <td className='w-250'>
                            <input type="text" id="txtIntellectualDiability_4" name="txtIntellectualDiability_4" className='add-only' />
                        </td>
                        <td className='w-250'>&nbsp;</td>
                        <td className='w-250'>&nbsp;</td>
                    </tr>
                </table>
                <table>
                    <tr>
                        <td className='w-750'><span className='eleHeader'>n. JUDGMENT</span> </td>
                    </tr>
                    <tr>
                        <td className='w-250'>
                            <input type="checkbox" id="cbJudgment_1" name="cbJudgment_1" className='add-only' value="Judgment_1" />
                            Critical Judgment Intact;
                        </td>
                        <td className='w-250'>
                            <input type="checkbox" id="cbJudgment_2" name="cbJudgment_2" className='add-only' value="Judgment_2" />
                            Impaired Judgment;
                        </td>
                        <td className='w-250'>&nbsp;</td>
                    </tr>
                    <tr>
                        <td className='w-250'>
                            <input type="checkbox" id="cbJudgment_3" name="cbJudgment_3" className='add-only' value="Judgment_3" />Other/Describe:
                        </td>
                        <td className='w-250'>&nbsp;</td>
                        <td className='w-250'>&nbsp;</td>
                    </tr>
                    <tr>
                        <td className='w-250'>
                            <input type="text" id="txtJudgment_3" name="txtJudgment_3" className='add-only' />
                        </td>
                        <td className='w-250'>&nbsp;</td>
                        <td className='w-250'>&nbsp;</td>
                    </tr>
                </table>
                <table>
                    <tr>
                        <td className='w-750'><span className='eleHeader'>o. INSIGHT</span> </td>
                    </tr>
                    <tr>
                        <td className='w-250'>
                            <input type="checkbox" id="cbInsight_1" name="cbInsight_1" className='add-only' value="Insight_1" />
                            True Emotional Insight;
                        </td>
                        <td className='w-250'>
                            <input type="checkbox" id="cbInsight_2" name="cbInsight_2" className='add-only' value="Insight_2" />
                            Intellectual Insight;
                        </td>
                        <td className='w-250'>
                            <input type="checkbox" id="cbInsight_3" name="cbInsight_3" className='add-only' value="Insight_3" />
                            Impaired Insight;
                        </td>
                    </tr>
                    <tr>
                        <td className='w-250'>
                            <input type="checkbox" id="cbInsight_4" name="cbInsight_4" className='add-only' value="Insight_4" />
                            Denial;
                        </td>
                        <td className='w-750'>
                            <input type="checkbox" id="cbInsight_5" name="cbInsight_5" className='add-only' value="Insight_5" />
                            Some Awareness of Illness/symptoms;
                        </td>
                    </tr>
                    <tr>
                        <td className='w-250'>
                            <input type="checkbox" id="cbInsight_6" name="cbInsight_6" className='add-only' value="Insight_6" />Other/Describe:
                        </td>
                        <td className='w-250'>&nbsp;</td>
                        <td className='w-250'>&nbsp;</td>
                    </tr>
                    <tr>
                        <td className='w-250'>
                            <input type="text" id="txtInsight_6" name="txtInsight_6" className='add-only' />
                        </td>
                        <td className='w-250'>&nbsp;</td>
                        <td className='w-250'>&nbsp;</td>
                    </tr>
                </table>
                <table>
                    <tr>
                        <td className='w-750'><span className='eleHeader'>p. IMPULSE CONTROL</span> </td>
                    </tr>
                    <tr>
                        <td className='w-250'>
                            <input type="checkbox" id="cbImpulseControl_1" name="cbImpulseControl_1" className='add-only' value="ImpulseControl_1" />
                            Able to Resist Impulses;
                        </td>
                        <td className='w-250'>
                            <input type="checkbox" id="cbImpulseControl_2" name="cbImpulseControl_2" className='add-only' value="ImpulseControl_2" />
                            Recent Impulsive Behavior;
                        </td>
                        <td className='w-250'>
                            <input type="checkbox" id="cbImpulseControl_3" name="cbImpulseControl_3" className='add-only' value="ImpulseControl_3" />
                            Impaired Impulse Control;
                        </td>
                    </tr>
                    <tr>
                        <td className='w-250'>
                            <input type="checkbox" id="cbImpulseControl_4" name="cbImpulseControl_4" className='add-only' value="ImpulseControl_4" />
                            Compulsions;
                        </td>
                        <td className='w-250'>&nbsp;</td>
                        <td className='w-250'>&nbsp;</td>
                    </tr>
                    <tr>
                        <td className='w-250'>
                            <input type="checkbox" id="cbImpulseControl_5" name="cbImpulseControl_5" className='add-only' value="ImpulseControl_5" />Other/Describe:
                        </td>
                        <td className='w-250'>&nbsp;</td>
                        <td className='w-250'>&nbsp;</td>
                    </tr>
                    <tr>
                        <td className='w-250'>
                            <input type="text" id="txtImpulseControl_5" name="txtImpulseControl_5" className='add-only' />
                        </td>
                        <td className='w-250'>&nbsp;</td>
                        <td className='w-250'>&nbsp;</td>
                    </tr>
                </table>
                <p className='w-750'>
                    <strong>XVII. RISK ASSESSMENT:</strong> <span className='small'>Assess potential risk of harm to self or others, including patterns of risk behavior and/or risk due to personality factors, substance use, criminogenic factors, exposure to elements, exploitation, abuse, neglect, suicidal or homicidal history, self-injury, psychosis, impulsiveness, etc. </span>
                </p>
                <table>
                    <tr>
                        <td className='w-750'><span className='eleHeader'>a. Risk of Harm to Self:</span> </td>
                    </tr>
                    <tr>
                        <td className='w-375'>
                            <input type="checkbox" id="cbRiskHarmSelf_1" name="cbRiskHarmSelf_1" className='add-only' value="RiskHarmSelf_1" />
                            Prior Suicide Attempt;
                        </td>
                        <td className='w-375'>
                            <input type="checkbox" id="cbRiskHarmSelf_2" name="cbRiskHarmSelf_2" className='add-only' value="RiskHarmSelf_2" />
                            Stated Plan/Intent;
                        </td>
                    </tr>
                    <tr>
                        <td className='w-375'>
                            <input type="checkbox" id="cbRiskHarmSelf_3" name="cbRiskHarmSelf_3" className='add-only' value="RiskHarmSelf_3" />
                            Access to means (weapons, pills, etc.);
                        </td>
                        <td className='w-375'>
                            <input type="checkbox" id="cbRiskHarmSelf_4" name="cbRiskHarmSelf_4" className='add-only' value="RiskHarmSelf_4" />
                            Recent Loss;
                        </td>
                    </tr>
                    <tr>
                        <td className='w-750'>
                            <input type="checkbox" id="cbRiskHarmSelf_5" name="cbRiskHarmSelf_5" className='add-only' value="RiskHarmSelf_5" />
                            Presence of Behavioral Cues (isolation, giving away possessions, rapid mood swings, etc.);
                        </td>
                    </tr>
                    <tr>
                        <td className='w-375'>
                            <input type="checkbox" id="cbRiskHarmSelf_6" name="cbRiskHarmSelf_6" className='add-only' value="RiskHarmSelf_6" />
                            Family History of Suicide;
                        </td>
                        <td className='w-375'>
                            <input type="checkbox" id="cbRiskHarmSelf_7" name="cbRiskHarmSelf_7" className='add-only' value="RiskHarmSelf_7" />
                            Terminal Illness;
                        </td>
                    </tr>
                    <tr>
                        <td className='w-375'>
                            <input type="checkbox" id="cbRiskHarmSelf_8" name="cbRiskHarmSelf_8" className='add-only' value="RiskHarmSelf_8" />
                            Substance Abuse;
                        </td>
                        <td className='w-375'>
                            <input type="checkbox" id="cbRiskHarmSelf_9" name="cbRiskHarmSelf_9" className='add-only' value="RiskHarmSelf_9" />
                            Marked lack of support;
                        </td>
                    </tr>
                    <tr>
                        <td className='w-375'>
                            <input type="checkbox" id="cbRiskHarmSelf_10" name="cbRiskHarmSelf_10" className='add-only' value="RiskHarmSelf_10" />
                            Psychosis;
                        </td>
                        <td className='w-375'>
                            <input type="checkbox" id="cbRiskHarmSelf_11" name="cbRiskHarmSelf_11" className='add-only' value="RiskHarmSelf_11" />
                            Suicide of friend/acquaintance;
                        </td>
                    </tr>
                    <tr>
                        <td className='w-375'>
                            <input type="checkbox" id="cbRiskHarmSelf_12" name="cbRiskHarmSelf_12" className='add-only' value="RiskHarmSelf_12" />Other/Describe:
                        </td>
                        <td className='w-375'>&nbsp;</td>
                    </tr>
                    <tr>
                        <td className='w-375'>
                            <input type="text" id="txtRiskHarmSelf_12" name="txtRiskHarmSelf_12" className='add-only' />
                        </td>
                        <td className='w-375'>&nbsp;</td>
                    </tr>
                </table>
                <p className='w-750'>
                    If had suicide ideation/attempt/plan please explain nature and dates, was hospitalization required:
                    <textarea id="txtRiskHarmSelfHospitalizationRequired" name="txtRiskHarmSelfHospitalizationRequired" className='add-only'></textarea>
                </p>




                <table>
                    <tr>
                        <td className='w-750'><span className='eleHeader'>b. Risk of Harm to Others:</span> </td>
                    </tr>
                    <tr>
                        <td className='w-375'>
                            <input type="checkbox" id="cbRiskHarmOthers_1" name="cbRiskHarmOthers_1" className='add-only' value="RiskHarmOthers_1" />
                            Prior acts of violence;
                        </td>
                        <td className='w-375'>
                            <input type="checkbox" id="cbRiskHarmOthers_2" name="cbRiskHarmOthers_2" className='add-only' value="RiskHarmOthers_2" />
                            Destruction of property;
                        </td>
                    </tr>
                    <tr>
                        <td className='w-375'>
                            <input type="checkbox" id="cbRiskHarmOthers_3" name="cbRiskHarmOthers_3" className='add-only' value="RiskHarmOthers_3" />
                            Arrests for violence;
                        </td>
                        <td className='w-375'>
                            <input type="checkbox" id="cbRiskHarmOthers_4" name="cbRiskHarmOthers_4" className='add-only' value="RiskHarmOthers_4" />
                            Access to means (weapons);
                        </td>
                    </tr>
                    <tr>
                        <td className='w-375'>
                            <input type="checkbox" id="cbRiskHarmOthers_5" name="cbRiskHarmOthers_5" className='add-only' value="RiskHarmOthers_5" />
                            Substance use;
                        </td>
                        <td className='w-375'>
                            <input type="checkbox" id="cbRiskHarmOthers_6" name="cbRiskHarmOthers_6" className='add-only' value="RiskHarmOthers_6" />
                            Physically abused as child;
                        </td>
                    </tr>
                    <tr>
                        <td className='w-375'>
                            <input type="checkbox" id="cbRiskHarmOthers_7" name="cbRiskHarmOthers_7" className='add-only' value="RiskHarmOthers_7" />
                            Was physically abusive as a child;
                        </td>
                        <td className='w-375'>
                            <input type="checkbox" id="cbRiskHarmOthers_8" name="cbRiskHarmOthers_8" className='add-only' value="RiskHarmOthers_8" />
                            Harms animals;
                        </td>
                    </tr>
                    <tr>
                        <td className='w-375'>
                            <input type="checkbox" id="cbRiskHarmOthers_9" name="cbRiskHarmOthers_9" className='add-only' value="RiskHarmOthers_9" />
                            Fire setting;
                        </td>
                        <td className='w-375'>
                            <input type="checkbox" id="cbRiskHarmOthers_10" name="cbRiskHarmOthers_10" className='add-only' value="RiskHarmOthers_10" />
                            angry mood/agitation;
                        </td>
                    </tr>
                    <tr>
                        <td className='w-375'>
                            <input type="checkbox" id="cbRiskHarmOthers_11" name="cbRiskHarmOthers_11" className='add-only' value="RiskHarmOthers_11" />
                            Prior hospitalizations for danger to others;
                        </td>
                        <td className='w-375'>&nbsp;</td>
                    </tr>
                    <tr>
                        <td className='w-750'>
                            <input type="checkbox" id="cbRiskHarmOthers_12" name="cbRiskHarmOthers_12" className='add-only' value="RiskHarmOthers_12" />
                            Psychosis/command hallucinations;
                        </td>
                    </tr>
                    <tr>
                        <td className='w-375'>
                            <input type="checkbox" id="cbRiskHarmOthers_13" name="cbRiskHarmOthers_13" className='add-only' value="RiskHarmOthers_13" />Other/Describe:
                        </td>
                        <td className='w-375'>&nbsp;</td>
                    </tr>
                    <tr>
                        <td className='w-375'>
                            <input type="text" id="txtRiskHarmOthers_13" name="txtRiskHarmOthers_13" className='add-only' />
                        </td>
                        <td className='w-375'>&nbsp;</td>
                    </tr>
                </table>

                <p className='w-750'>
                    If had suicide ideation/attempt/plan please explain nature and dates, was hospitalization required:
                    <textarea id="txtRiskHarmOthersHospitalizationRequired" name="txtRiskHarmOthersHospitalizationRequired" className='add-only'></textarea>
                </p>


                <table>
                    <tr>
                        <td className='w-750'><span className='eleHeader'>c. Client/Member Safety & Other Risk Factors:</span> </td>
                    </tr>
                    <tr>
                        <td className='w-375'>
                            <input type="checkbox" id="cbClientMemberSafety_1" name="cbClientMemberSafety_1" className='add-only' value="ClientMemberSafety_1" />
                            Feels unsafe in current living environment </td>
                        <td className='w-375'>
                            <input type="checkbox" id="cbClientMemberSafety_2" name="cbClientMemberSafety_2" className='add-only' value="ClientMemberSafety_2" />Engages in dangerous sexual behavior
                        </td>
                    </tr>



                    <tr>
                        <td className='w-750'>
                            <input type="checkbox" id="cbClientMemberSafety_3" name="cbClientMemberSafety_3" className='add-only' value="ClientMemberSafety_3" />Feels currently being harmed/hurt/abused/threatened by someone;
                        </td>
                    </tr>
                    <tr>
                        <td className='w-750'>
                            <input type="checkbox" id="cbClientMemberSafety_4" name="cbClientMemberSafety_4" className='add-only' value="ClientMemberSafety_4" />Past involvement with Child or Adult Protective Services;
                        </td>
                    </tr>
                    <tr>
                        <td className='w-375'>
                            <input type="checkbox" id="cbClientMemberSafety_5" name="cbClientMemberSafety_5" className='add-only' value="ClientMemberSafety_5" />
                            Relapse/decompensation triggers; </td>
                    </tr>
                    <tr>
                        <td className='w-375'>
                            <input type="checkbox" id="cbClientMemberSafety_6" name="cbClientMemberSafety_6" className='add-only' value="ClientMemberSafety_6" />Other/Describe: </td>
                        <td className='w-375'>&nbsp;</td>
                    </tr>
                    <tr>
                        <td className='w-375'>
                            <input type="text" id="txtClientMemberSafety_6" name="txtClientMemberSafety_6" className='add-only' />
                        </td>
                        <td className='w-375'>&nbsp;</td>
                    </tr>
                </table>

                <p className='w-750'>
                    <span className='eleHeader'>d.
                    </span>
                </p>
                <table>
                    <tr>
                        <td className='w-250'>
                            <input type="checkbox" id="cbInappropriate" name="cbInappropriate" className='add-only' value="Inappropriate" />Inappropriate sexual behaviors
                        </td>
                        <td className='w-250'>
                            <input type="checkbox" id="cbSexOffender" name="cbSexOffender" className='add-only' value="SexOffender" />Sex offender status
                        </td>
                        <td className='w-250'>
                            <input type="checkbox" id="cbPendingSexOffense" name="cbPendingSexOffense" className='add-only' value="PendingSexOffense" />Pending sex offense charge
                        </td>
                    </tr>
                    <tr>
                        <td className='w-250'>
                            <input type="checkbox" id="cbReportInvestigation" name="cbReportInvestigation" className='add-only' value="ReportInvestigation" />
                            Report or Investigation
                        </td>
                        <td className='w-250'>&nbsp;</td>
                        <td className='w-250'>&nbsp;</td>
                    </tr>
                    <tr>
                        <td className='w-250'>
                            <input type="checkbox" id="cbOtherXXII" name="cbOtherXXII" className='add-only' value="OtherXXII" />
                            Other:
                        </td>
                        <td className='w-250'>&nbsp;</td>
                        <td className='w-250'>&nbsp;</td>
                    </tr>
                    <tr>
                        <td>
                            <input type="text" id="txtOtherXXII" name="txtOtherXXII" className='add-only' />
                        </td>
                        <td className='w-250'>&nbsp;</td>
                        <td className='w-250'>&nbsp;</td>
                    </tr>
                </table>
                <p className='w-750'>
                    <span className='eleHeader'>e. Additional Risk Factors</span>
                    <textarea id="txtAdditionalRiskfactors" name="AdditionalRsikfactors" className='add-only'></textarea>
                </p>
                <p className='w-750'>
                    <span className='eleHeader'>f. Describe recipient's preferences and desires for addressing risk factors, including any Mental Health Advance Directives or plan of response to periods of decompensation/relapse (Ex. Resources recipient feels comfortable reaching out to for assistance in a crisis.):</span>
                    <textarea id="txtDescribeRecipientPreferences" name="txtDescribeRecipientPreferences" className='add-only'></textarea>
                </p>

                <p className='w-750'><strong>XVIII. CULTURAL AND LANGUAGE PREFERENCES</strong> <span className='small'>(Language, Customs/Values/Preferences)</span> </p>
                <p className='w-750'>
                    <span className='eleHeader'>a. Spiritual Beliefs/Preferences:
                    </span>
                    <textarea id="txtSpiritualBeliefsPreferences" name="txtSpiritualBeliefsPreferences" className='add-only'></textarea>
                </p>
                <p className='w-750'>
                    <span className='eleHeader'>b. Cultural Beliefs/Preferences:
                    </span>
                    <textarea id="txtCulturalBeliefsPreferences" name="txtCulturalBeliefsPreferences" className='add-only'></textarea>
                </p>

                <p className='w-750'>
                    <strong>XIX. PRINCIPAL DIAGNOSES </strong>
                </p>

                <p className='w-750'>
                    <span className='eleHeader'>AXIS I</span>
                    <textarea id="txtAxis1" name="Axis1" className='add-only'></textarea>
                </p>
                <p className='w-750'>
                    <span className='eleHeader'>AXIS II</span>
                    <textarea id="txtAxis2" name="Axis2" className='add-only'></textarea>
                </p>
                <p className='w-750'>
                    <span className='eleHeader'>AXIS III</span>
                    <textarea id="txtAxis3" name="Axis3" className='add-only'></textarea>
                </p>
                <p className='w-750'>
                    <span className='eleHeader'>AXIS IV</span>
                    <textarea id="txtAxis4" name="tAxis4" className='add-only'></textarea>
                </p>
                <p className='w-750'>
                    <span className='eleHeader'>AXIS V</span>
                    <textarea id="txtAxis5" name="tAxis5" className='add-only'></textarea>
                </p>
                
                <table>
                    <tr>
                        <td className='w-375'><span className='eleHeader'>Current:</span> </td>
                        <td className='w-375'><span className='eleHeader'>Highest Past Year:</span> </td>
                    </tr>
                    <tr>
                        <td className='w-375'>
                            <input type="text" id="txtCurrent" name="txtCurrent" className='add-only' /></td>
                        <td className='w-375'>
                            <input type="text" id="txtHighestPastYear" name="txtHighestPastYear" className='add-only' /></td>
                    </tr>
                </table>


                <p className='w-750'><strong>XX. INTERPRETATIVE SUMMARY:</strong></p>
                <p className='w-750'>
                    Briefly describe client/member's global preferences/hopes for recovery, your clinical summary, and recommended treatments/assessments, level of care, duration.
                    <textarea id="txtInterpretativeSummary" name="txtInterpretativeSummary" className='add-only'></textarea>
                </p>

                <p className='w-750'>
                    <span className='eleHeader'>a. Recommended Services</span>
                    <span className='small'>: (Check all that apply.)</span>

                </p>
                <table>
                    <tr>
                        <td className='w-250'>
                            <input type="checkbox" id="cbRecommendedServics_1" name="cbRecommendedServics_1" className='add-only' value="RecommendedServics_1" />Family Therapy;
                        </td>
                        <td className='w-250'>
                            <input type="checkbox" id="cbRecommendedServics_2" name="cbRecommendedServics_2" className='add-only' value="RecommendedServics_2" />Individual Therapy;
                        </td>
                        <td className='w-250'>
                            <input type="checkbox" id="cbRecommendedServics_3" name="cbRecommendedServics_3" className='add-only' value="RecommendedServics_3" />Group Therapy;
                        </td>
                    </tr>
                    <tr>
                        <td className='w-250'>
                            <input type="checkbox" id="cbRecommendedServics_4" name="cbRecommendedServics_4" className='add-only' value="RecommendedServics_4" />Alcohol/Drug Assessment;
                        </td>
                        <td className='w-250'>
                            <input type="checkbox" id="cbRecommendedServics_5" name="cbRecommendedServics_5" className='add-only' value="RecommendedServics_5" />Alcohol/ Drug Individual Therapy;
                        </td>
                        <td className='w-250'>
                            <input type="checkbox" id="cbRecommendedServics_6" name="cbRecommendedServics_6" className='add-only' value="RecommendedServics_6" />PSR;
                        </td>
                    </tr>
                    <tr>
                        <td className='w-250'>
                            <input type="checkbox" id="cbRecommendedServics_7" name="cbRecommendedServics_7" className='add-only' value="RecommendedServics_7" />CPST;
                        </td>
                        <td className='w-250'>&nbsp;</td>
                        <td className='w-250'>&nbsp;</td>
                    </tr>
                    <tr>
                        <td className='w-250'>
                            <input type="checkbox" id="cbRecommendedServics_9" name="cbRecommendedServics_9" className='add-only' value="RecommendedServics_9" />Other/Describe:
                        </td>
                        <td className='w-250'>&nbsp;</td>
                        <td className='w-250'>&nbsp;</td>
                    </tr>
                    <tr>
                        <td>
                            <input type="text" id="txtRecommendedServicsOther" name="txtRecommendedServicsOther" className='add-only' />
                        </td>
                        <td className='w-250'>&nbsp;</td>
                        <td className='w-250'>&nbsp;</td>
                    </tr>
                </table>
                <p className='w-750'><strong>b. Other Services/Linkages Needed:</strong></p>
                <table>
                    <tr>
                        <td className='w-250'>
                            <input type="checkbox" id="cbOtherServices_1" name="cbOtherServices_1" className='add-only' value="OtherServices_1" />Vocational Services;
                        </td>
                        <td className='w-250'>
                            <input type="checkbox" id="cbOtherServices_2" name="cbOtherServices_2" className='add-only' value="OtherServices_2" />Social Services;
                        </td>
                        <td className='w-250'>
                            <input type="checkbox" id="cbOtherServices_3" name="cbOtherServices_3" className='add-only' value="OtherServices_3" />Educational Services;
                        </td>
                    </tr>
                    <tr>
                        <td className='w-250'>
                            <input type="checkbox" id="cbOtherServices_4" name="cbOtherServices_4" className='add-only' value="OtherServices_4" />Medical Services/PCP;
                        </td>
                        <td className='w-250'>
                            <input type="checkbox" id="cbOtherServices_5" name="cbOtherServices_5" className='add-only' value="OtherServices_5" />Self-help Groups;
                        </td>
                        <td className='w-250'>&nbsp;</td>
                    </tr>
                    <tr>
                        <td className='w-250'>
                            <input type="checkbox" id="cbOtherServices_6" name="cbOtherServices_6" className='add-only' value="OtherServices_5" />
                            Other/Describe:
                        </td>
                        <td className='w-250'>&nbsp;</td>
                        <td className='w-250'>&nbsp;</td>
                    </tr>
                    <tr>
                        <td className='w-250'>
                            <input type="text" id="txtOtherServices" name="OtherServices" className='add-only' />
                        </td>
                        <td className='w-250'>&nbsp;</td>
                        <td className='w-250'>&nbsp;</td>
                    </tr>
                </table>
                <p className='w-750'>
                    <strong>c. Additional Comments:</strong>
                    <textarea id="txtAdditionalComments" name="txtAdditionalComments" className='add-only'></textarea>
                </p>
                <p className='w-750'><strong>SIGNATURE</strong> </p>
                <table>
                    <tr>
                        <td className='signature w-500'>&nbsp;</td>
                        <td className='signature w-250'>&nbsp;</td>
                    </tr>
                    <tr>
                        <td className='small w-500'>Signature:</td>
                        <td className='small w-250'>Date:</td>
                    </tr>
                </table>
                <table>
                    <tr>
                        <td className='signature w-375'>&nbsp;</td>
                        <td className='signature w-375'>&nbsp;</td>
                    </tr>
                    <tr>
                        <td className='small w-375'>PRINTED NAME OF ASSESSOR:</td>
                        <td className='small w-375'>LMHP STATUS:</td>
                    </tr>
                </table>




            </div>
        </form>

    )
}